<template>
  <v-container fluid class="py-0" grid-list-md>
    <v-row v-if="lAction === 'view'">
      <v-col>
        <v-layout row wrap>
          <v-card>
            <v-card-title class="pa-2 grey lighten-2">
              <div class="ml-4 title primary--text" style="margin-top: -5px; margin-right: 120px;"><strong>Ticket Metrics Details</strong></div>
              <v-flex xs2 sm2>
                <v-combobox
                v-model="lBbSupport.dep_pair"
                :items="departmentList"
                label="Select Department"
                item-value="dept_id"
                item-text="dept_name"
                :rules="[rules.required]"
                hide-details
                dense
                outlined
                return-object
                small-chips
                color="primary"
                ></v-combobox>
              </v-flex>
              <v-flex xs2 sm2 class="ml-3">
                <v-dialog ref="dlgFromDate"
                persistent v-model="dlgFromDate"
                max-width="290px"
                :return-value.sync="lDateFrom">
                <template v-slot:activator="{ on }">
                  <v-text-field
                  slot="activator" label="From"
                  v-model="lDateFrom" append-icon="mdi-calendar-today"
                  readonly
                  v-on="on"
                  hide-details
                  outlined
                  dense
                  color="primary"
                  style="font-size: 12px"
                  ></v-text-field>
                </template>
                <v-date-picker v-model="lDateFrom"
                first-day-of-week="1">
                <v-spacer></v-spacer>
                <v-btn text @click="dlgFromDate = false">Cancel</v-btn>
                <v-btn text color="accent" @click="$refs.dlgFromDate.save(lDateFrom)">OK</v-btn>
              </v-date-picker>
            </v-dialog>
          </v-flex>
          <v-flex xs2 sm2 class="ml-2 mr-2">
            <v-dialog ref="dlgToDate"
            persistent v-model="dlgToDate"
            max-width="290px"
            :return-value.sync="lDateTo">
            <template v-slot:activator="{ on }">
              <v-text-field
              slot="activator" label="To"
              v-model="lDateTo" append-icon="mdi-calendar-today"
              readonly
              v-on="on"
              hide-details
              outlined
              dense
              color="primary"
              style="font-size: 12px"
              ></v-text-field>
            </template>
            <v-date-picker v-model="lDateTo"
            first-day-of-week="1">
            <v-spacer></v-spacer>
            <v-btn text @click="dlgToDate = false">Cancel</v-btn>
            <v-btn text color="accent" @click="$refs.dlgToDate.save(lDateTo)">OK</v-btn>
          </v-date-picker>
        </v-dialog>
      </v-flex>
      <v-btn fab small class="ml-2 mr-5" color="accent" @click="refreshDashBoard()"><strong>Go</strong></v-btn>
      <v-btn small color="accent"  @click="createSla"><strong>SLA</strong></v-btn>
    </v-card-title>
    <v-card-text class="pt-3">
      <v-layout row wrap>
        <v-flex xs7>
          <v-layout row wrap>
            <!-- 1. row -->
            <v-flex xs12 rounded style="margin-top: 10px;">
              <v-layout>
                <v-flex xs4>
                  <v-card class="grey lighten-4" style="height: 88px;">
                    <v-list-item>
                      <v-sheet
                      elevation="5"
                      height="45"
                      width="45"
                      class="amber darken-4"
                      style="margin-top: -20px;">
                      <v-icon large color="white" class="pa-1">mdi-ticket</v-icon>
                    </v-sheet>
                  </v-list-item>
                  <v-spacer></v-spacer>
                  <div class="mr-3" style="margin-top: -40px; text-align:right; font-family: Roboto,sans-serif!important; font-size: 12px; color: #555555">Total Tickets</div>
                  <div class="mr-3 mt-1" style="text-align:right; font-family: Roboto,sans-serif!important; font-size: 20px; color: #333333;">{{dashboardTicketDetail[0] && dashboardTicketDetail[0].tot_ticket}}</div>
                  <div class="pl-2 pr-2 pb-1 pt-2" > <hr></hr></div>
                  <div class="pl-2" style="text-align:left; font-family: Roboto,sans-serif!important; font-size: 10px; color: #999999; line-height: 1.4em" @click="loadTicketsDetails('Total Tickets')"><v-icon class="mr-1" small>mdi-open-in-new</v-icon>Total Tickets Raised Till Date</div>
                </v-card>
              </v-flex>
              <v-flex xs4>
                <v-card class="grey lighten-4" style="height: 88px; margin-left: 10px;">
                  <v-list-item>
                    <v-sheet
                    elevation="5"
                    height="45"
                    width="45"
                    class="cyan darken-3"
                    style="margin-top: -20px;">
                    <v-icon large color="white" class="pa-1">mdi-ticket-account</v-icon>
                  </v-sheet>
                </v-list-item>
                <v-spacer></v-spacer>
                <div class="mr-3" style="margin-top: -40px; text-align:right; font-family: Roboto,sans-serif!important; font-size: 12px; color: #555555">Open Tickets</div>
                <div class="mr-3 mt-1" style="text-align:right; font-family: Roboto,sans-serif!important; font-size: 20px; color: #333333; ">{{dashboardTicketDetail[0] && dashboardTicketDetail[0].open_ticket}}</div>
                <div class="pl-2 pr-2 pb-1 pt-2" > <hr></hr></div>
                <div class="pl-2" style="text-align:left; font-family: Roboto,sans-serif!important; font-size: 10px; color: #999999; line-height: 1.4em" @click="loadTicketsDetails('Open Tickets')"><v-icon class="mr-1" small>mdi-open-in-new</v-icon>Total Open Tickets Till Date</div>
              </v-card>
            </v-flex>
            <v-flex xs4>
              <v-card class="grey lighten-4" style="height: 88px; margin-left: 10px;">
                <v-list-item>
                  <v-sheet
                  elevation="5"
                  height="45"
                  width="45"
                  class="green"
                  style="margin-top: -20px;">
                  <v-icon large color="white" class="pa-1">mdi-playlist-check</v-icon>
                </v-sheet>
              </v-list-item>
              <v-spacer></v-spacer>
              <div class="mr-3" style="margin-top: -40px; text-align:right; font-family: Roboto,sans-serif!important; font-size: 12px; color: #555555">Closed Tickets</div>
              <div class="mr-3 mt-1" style="text-align:right; font-family: Roboto,sans-serif!important; font-size: 20px; color: #333333; ">{{dashboardTicketDetail[0] && dashboardTicketDetail[0].closed_ticket}}</div>
              <div class="pl-2 pr-2 pb-1 pt-2" > <hr></hr></div>
              <div class="pl-2" style="text-align:left; font-family: Roboto,sans-serif!important; font-size: 10px; color: #999999; line-height: 1.4em" @click="loadTicketsDetails('Closed Tickets')"><v-icon class="mr-1" small>mdi-open-in-new</v-icon>Total Closed Tickets Till Date</div>
            </v-card>
          </v-flex>
        </v-layout>
      </v-flex>
      <!-- 2. row -->
      <v-flex xs12 rounded style="margin-top: 10px;">
        <v-layout>
          <v-flex xs4>
            <v-card class="grey lighten-4" style="height: 88px;">
              <v-list-item>
                <v-sheet
                elevation="5"
                height="45"
                width="45"
                class=""
                style="margin-top: -20px; backgroundColor: #D81B60;">
                <v-icon large color="white" class="pa-1">mdi-playlist-plus</v-icon>
              </v-sheet>
            </v-list-item>
            <v-spacer></v-spacer>
            <div class="mr-3" style="margin-top: -40px; text-align:right; font-family: Roboto,sans-serif!important; font-size: 12px; color: #555555">New Tickets</div>
            <div class="mr-3 mt-1" style="text-align:right; font-family: Roboto,sans-serif!important; font-size: 20px; color: #333333; ">{{dashboardTicketDetail[0] && dashboardTicketDetail[0].new_ticket}}</div>
            <div class="pl-2 pr-2 pb-1 pt-2" > <hr></hr></div>
            <div class="pl-2" style="text-align:left; font-family: Roboto,sans-serif!important; font-size: 10px; color: #999999; line-height: 1.4em" @click="loadTicketsDetails('New Tickets')"><v-icon class="mr-1" small>mdi-open-in-new</v-icon>Total Tickets with <strong>New</strong> Status</div>
          </v-card>
        </v-flex>
        <v-flex xs4>
          <v-card class="grey lighten-4" style="height: 88px; margin-left: 10px;">
            <v-list-item>
              <v-sheet
              elevation="5"
              height="45"
              width="45"
              class="success"
              style="margin-top: -20px;">
              <v-icon large color="white" class="pa-1">mdi-playlist-minus</v-icon>
            </v-sheet>
          </v-list-item>
          <v-spacer></v-spacer>
          <div class="mr-3" style="margin-top: -40px; text-align:right; font-family: Roboto,sans-serif!important; font-size: 12px; color: #555555">Job-Done Tickets</div>
          <div class="mr-3 mt-1" style="text-align:right; font-family: Roboto,sans-serif!important; font-size: 20px; color: #333333; ">{{dashboardTicketDetail[0] && dashboardTicketDetail[0].job_done_ticket}}</div>
          <div class="pl-2 pr-2 pb-1 pt-2" > <hr></hr></div>
          <div class="pl-2" style="text-align:left; font-family: Roboto,sans-serif!important; font-size: 10px; color: #999999; line-height: 1.4em" @click="loadTicketsDetails('Job-Done Tickets')"><v-icon class="mr-1" small>mdi-open-in-new</v-icon>Total Tickets with <strong>Job-Done</strong></div>
        </v-card>
      </v-flex>
      <v-flex xs4>
        <v-card class="grey lighten-4" style="height: 88px; margin-left: 10px;">
          <v-list-item>
            <v-sheet
            elevation="5"
            height="45"
            width="45"
            class=""
            style="margin-top: -20px; backgroundColor: #283593;">
            <v-icon large color="white" class="pa-1">mdi-account-off</v-icon>
          </v-sheet>
        </v-list-item>
        <v-spacer></v-spacer>
        <div class="mr-3" style="margin-top: -40px; text-align:right; font-family: Roboto,sans-serif!important; font-size: 12px; color: #555555">Un-Assigned</div>
        <div class="mr-3 mt-1" style="text-align:right; font-family: Roboto,sans-serif!important; font-size: 20px; color: #333333; ">{{dashboardTicketDetail[0] && dashboardTicketDetail[0].unassigned_ticket}}</div>
        <div class="pl-2 pr-2 pb-1 pt-2" > <hr></hr></div>
        <div class="pl-2" style="text-align:left; font-family: Roboto,sans-serif!important; font-size: 10px; color: #999999; line-height: 1.4em" @click="loadTicketsDetails('UnAssigned Tickets')"><v-icon class="mr-1" small>mdi-open-in-new</v-icon>Total Un-Assigned Till Date</div>
      </v-card>
    </v-flex>
  </v-layout>
</v-flex>
<!-- 3. row -->
<v-flex xs12 rounded style="margin-top: 10px;">
  <v-layout>
    <v-flex xs4>
      <v-card class="grey lighten-4" style="height: 88px;">
        <v-list-item>
          <v-sheet
          elevation="5"
          height="45"
          width="45"
          class="red"
          style="margin-top: -20px;">
          <v-icon large color="white" class="pa-1">mdi-timer-sand</v-icon>
        </v-sheet>
      </v-list-item>
      <v-spacer></v-spacer>
      <div class="mr-3" style="margin-top: -40px; text-align:right; font-family: Roboto,sans-serif!important; font-size: 12px; color: #555555">Total On-Hold</div>
      <div class="mr-3 mt-1" style="text-align:right; font-family: Roboto,sans-serif!important; font-size: 20px; color: #333333; ">{{dashboardTicketDetail[0] && dashboardTicketDetail[0].on_hold_ticket}}</div>
      <div class="pl-2 pr-2 pb-1 pt-2" > <hr></hr></div>
      <div class="pl-2" style="text-align:left; font-family: Roboto,sans-serif!important; font-size: 10px; color: #999999; line-height: 1.4em" @click="loadTicketsDetails('On-Hold Tickets')"><v-icon class="mr-1" small>mdi-open-in-new</v-icon>Total On-Hold tickets</div>
    </v-card>
  </v-flex>
  <v-flex xs4>
    <v-card class="grey lighten-4" style="height: 88px; margin-left: 10px;">
      <v-list-item>
        <v-sheet
        elevation="5"
        height="45"
        width="45"
        class="red"
        style="margin-top: -20px;">
        <v-icon large color="white" class="pa-1">mdi-calendar-remove</v-icon>
      </v-sheet>
    </v-list-item>
    <v-spacer></v-spacer>
    <div class="mr-3" style="margin-top: -40px; text-align:right; font-family: Roboto,sans-serif!important; font-size: 12px; color: #555555">Closed SLA Missed</div>
    <div class="mr-3 mt-1" style="text-align:right; font-family: Roboto,sans-serif!important; font-size: 20px; color: #333333; ">{{dashboardSLATicketCount[0] && dashboardSLATicketCount[0].closed_sla_missed}}</div>
    <div class="pl-2 pr-2 pb-1 pt-2" > <hr></hr></div>
    <div class="pl-2" style="text-align:left; font-family: Roboto,sans-serif!important; font-size: 10px; color: #999999; line-height: 1.4em" @click="loadTicketsDetails('Closed SLA Missed')"><v-icon class="mr-1" small>mdi-open-in-new</v-icon>Total Closed Tickets SLA Missed</div>
  </v-card>
</v-flex>
<v-flex xs4>
  <v-card class="grey lighten-4" style="height: 88px; margin-left: 10px;">
    <v-list-item>
      <v-sheet
      elevation="5"
      height="45"
      width="45"
      class="deep-orange lighten-1"
      style="margin-top: -20px;">
      <v-icon large color="white" class="pa-1">mdi-clock-alert</v-icon>
    </v-sheet>
  </v-list-item>
  <v-spacer></v-spacer>
  <div class="mr-3" style="margin-top: -40px; text-align:right; font-family: Roboto,sans-serif!important; font-size: 12px; color: #555555">Open SLA Missed</div>
  <div class="mr-3 mt-1" style="text-align:right; font-family: Roboto,sans-serif!important; font-size: 20px; color: #333333; ">{{dashboardSLATicketCount[0] && dashboardSLATicketCount[0].open_sla_missed}}</div>
  <div class="pl-2 pr-2 pb-1 pt-2" > <hr></hr></div>
  <div class="pl-2" style="text-align:left; font-family: Roboto,sans-serif!important; font-size: 10px; color: #999999; line-height: 1.4em" @click="loadTicketsDetails('Open SLA Missed')"><v-icon class="mr-1" small>mdi-open-in-new</v-icon>Total Open Tickets SLA Missed</div>
</v-card>
</v-flex>
</v-layout>
</v-flex>
<!-- 4. row -->
<v-flex xs12 rounded style="margin-top: 10px;">
  <v-layout>
    <v-flex xs4>
      <v-card class="grey lighten-4" style="height: 88px;">
        <v-list-item>
          <v-sheet
          elevation="5"
          height="45"
          width="45"
          class="primary lighten-1"
          style="margin-top: -20px;">
          <v-icon large color="white" class="pa-1">mdi-alarm-check</v-icon>
        </v-sheet>
      </v-list-item>
      <v-spacer></v-spacer>
      <div class="mr-3" style="margin-top: -40px; text-align:right; font-family: Roboto,sans-serif!important; font-size: 12px; color: #555555">Aged < 30 days</div>
      <div class="mr-3 mt-1" style="text-align:right; font-family: Roboto,sans-serif!important; font-size: 20px; color: #333333; ">{{dashboardAgedTicketCount[0] && dashboardAgedTicketCount[0].less30days}}</div>
      <div class="pl-2 pr-2 pb-1 pt-2" > <hr></hr></div>
      <div class="pl-2" style="text-align:left; font-family: Roboto,sans-serif!important; font-size: 10px; color: #999999; line-height: 1.4em" @click="loadTicketsDetails('Aged < 30 days')"><v-icon class="mr-1" small>mdi-open-in-new</v-icon>Open Tickets Aged < 30 days</div>
    </v-card>
  </v-flex>
  <v-flex xs4>
    <v-card class="grey lighten-4" style="height: 88px; margin-left: 10px;">
      <v-list-item>
        <v-sheet
        elevation="5"
        height="45"
        width="45"
        class="purple"
        style="margin-top: -20px;">
        <v-icon large color="white" class="pa-1">mdi-alarm</v-icon>
      </v-sheet>
    </v-list-item>
    <v-spacer></v-spacer>
    <div class="mr-3" style="margin-top: -40px; text-align:right; font-family: Roboto,sans-serif!important; font-size: 12px; color: #555555"> Aged 30 - 60 days</div>
    <div class="mr-3 mt-1" style="text-align:right; font-family: Roboto,sans-serif!important; font-size: 20px; color: #333333; ">{{dashboardAgedTicketCount[0] && dashboardAgedTicketCount[0].less30to60days}}</div>
    <div class="pl-2 pr-2 pb-1 pt-2" > <hr></hr></div>
    <div class="pl-2" style="text-align:left; font-family: Roboto,sans-serif!important; font-size: 10px; color: #999999; line-height: 1.4em" @click="loadTicketsDetails('Aged 30 - 60 days')"><v-icon class="mr-1" small>mdi-open-in-new</v-icon>Open Tickets Aged 30 to 60 days</div>
  </v-card>
</v-flex>
<v-flex xs4>
  <v-card class="grey lighten-4" style="height: 88px; margin-left: 10px;">
    <v-list-item>
      <v-sheet
      elevation="5"
      height="45"
      width="45"
      class="blue-grey"
      style="margin-top: -20px;">
      <v-icon large color="white" class="pa-1">mdi-alarm-multiple</v-icon>
    </v-sheet>
  </v-list-item>
  <v-spacer></v-spacer>
  <div class="mr-3" style="margin-top: -40px; text-align:right; font-family: Roboto,sans-serif!important; font-size: 12px; color: #555555"> Aged 60 - 90 days</div>
  <div class="mr-3 mt-1" style="text-align:right; font-family: Roboto,sans-serif!important; font-size: 20px; color: #333333; ">{{dashboardAgedTicketCount[0] && dashboardAgedTicketCount[0].less60to90days}}</div>
  <div class="pl-2 pr-2 pb-1 pt-2" > <hr></hr></div>
  <div class="pl-2" style="text-align:left; font-family: Roboto,sans-serif!important; font-size: 10px; color: #999999; line-height: 1.4em" @click="loadTicketsDetails('Aged 60 - 90 days')"><v-icon class="mr-1" small>mdi-open-in-new</v-icon>Open Tickets Aged 60 to 90 days</div>
</v-card>
</v-flex>
</v-layout>
</v-flex>
<!-- 5. row -->
<v-flex xs12 rounded style="margin-top: 10px;">
  <v-layout>
    <v-flex xs4>
      <v-card class="grey lighten-4" style="height: 88px;">
        <v-list-item>
          <v-sheet
          elevation="5"
          height="45"
          width="45"
          class="cyan"
          style="margin-top: -20px;">
          <v-icon large color="white" class="pa-1">mdi-alarm-off</v-icon>
        </v-sheet>
      </v-list-item>
      <v-spacer></v-spacer>
      <div class="mr-3" style="margin-top: -40px; text-align:right; font-family: Roboto,sans-serif!important; font-size: 12px; color: #555555"> Aged > 90 days</div>
      <div class="mr-3 mt-1" style="text-align:right; font-family: Roboto,sans-serif!important; font-size: 20px; color: #333333; ">{{dashboardAgedTicketCount[0] && dashboardAgedTicketCount[0].greater90days}}</div>
      <div class="pl-2 pr-2 pb-1 pt-2" > <hr></hr></div>
      <div class="pl-2" style="text-align:left; font-family: Roboto,sans-serif!important; font-size: 10px; color: #999999; line-height: 1.4em" @click="loadTicketsDetails('Aged > 90 days')"><v-icon class="mr-1" small>mdi-open-in-new</v-icon>Open Tickets Aged > 90 days</div>
    </v-card>
  </v-flex>
  <v-flex xs4>
    <v-card class="grey lighten-4" style="height: 88px; margin-left: 10px;">
      <v-list-item>
        <v-sheet
        elevation="5"
        height="45"
        width="45"
        class="teal accent-4"
        style="margin-top: -20px;">
        <v-icon large color="white" class="pa-1">mdi-watch-import</v-icon>
      </v-sheet>
    </v-list-item>
    <v-spacer></v-spacer>
    <div class="mr-3" style="margin-top: -40px; text-align:right; font-family: Roboto,sans-serif!important; font-size: 12px; color: #555555">Avg Response Time</div>
    <div class="mr-3 mt-1" style="text-align:right; font-family: Roboto,sans-serif!important; font-size: 15px; color: #333333; ">{{dashboardRespResolTime[0] && dashboardRespResolTime[0].ResponseTime}}</div>
    <div class="pl-2 pr-2 pb-1 pt-2" > <hr></hr></div>
    <div class="pl-2" style="text-align:left; font-family: Roboto,sans-serif!important; font-size: 10px; color: #999999; line-height: 1.4em"><v-icon class="mr-1" small>mdi-tag</v-icon>Avg Response Time for all tickets</div>
  </v-card>
</v-flex>
<v-flex xs4>
  <v-card class="grey lighten-4" style="height: 88px; margin-left: 10px;">
    <v-list-item>
      <v-sheet
      elevation="5"
      height="45"
      width="45"
      class="light-green accent-4"
      style="margin-top: -20px;">
      <v-icon large color="white" class="pa-1">mdi-watch-export</v-icon>
    </v-sheet>
  </v-list-item>
  <v-spacer></v-spacer>
  <div class="mr-3" style="margin-top: -40px; text-align:right; font-family: Roboto,sans-serif!important; font-size: 12px; color: #555555">Avg Resolution Time</div>
  <div class="mr-3 mt-1" style="text-align:right; font-family: Roboto,sans-serif!important; font-size: 15px; color: #333333; ">{{dashboardRespResolTime[0] && dashboardRespResolTime[0].ResolutionTime}}</div>
  <div class="pl-2 pr-2 pb-1 pt-2" > <hr></hr></div>
  <div class="pl-2" style="text-align:left; font-family: Roboto,sans-serif!important; font-size: 10px; color: #999999; line-height: 1.4em"><v-icon class="mr-1" small>mdi-tag</v-icon>Avg Resolution for all tickets</div>
</v-card>
</v-flex>
</v-layout>
</v-flex>
</v-layout>
</v-flex>
<v-flex xs5>
  <v-layout row wrap>
    <v-flex xs12 class="pt-8 mt-5 ml-2">
      <v-card class="elevation-6">
        <v-card-text>
          <v-layout xs12 row wrap class="pl-0 pr-0 text-center">
            <v-flex>
              <v-sheet
              style="margin-top: -50px; margin-left: 10px; margin-right: 10px; backgroundColor: #78909C"
              class="elevation-0"
              >
              <div id="div_chartDataForRaisedVsClosedTickets" class="elevation-7 pa-3" >
                <canvas id="chart_chartDataForRaisedVsClosedTickets"></canvas>
              </div>
              </v-sheet>
            </v-flex>
          </v-layout>
          <v-layout xs12 row wrap class="text-center">
            <v-flex>
              <v-layout row wrap class="pl-3 pr-1 text-left">
                <v-flex>
                  <div class="pt-2" style="font-family: Roboto,sans-serif!important; font-size: 14px; color: #555555; line-height: 1.4em">Total Raised vs Total Closed Trend for Last 6 Months</div>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-flex>
    <v-flex xs12 class="pt-10 ml-2">
      <v-card class="elevation-6">
        <v-card-text>
          <v-layout xs12 row wrap class="pl-0 pr-0 text-center">
            <v-flex>
              <v-sheet
              style="margin-top: -50px; margin-left: 10px; margin-right: 10px;  backgroundColor: #26A69A"
              class="elevation-0"
              rounded="xl"
              >
              <div id="div_chartDataForCurOpenTicketsFor6Months" class="elevation-7 pa-3" >
                <canvas id="chart_chartDataForCurOpenTicketsFor6Months"></canvas>
              </div>
            </v-sheet>
          </v-flex>
        </v-layout>
        <v-layout xs12 row wrap class="text-center">
          <v-flex>
            <v-layout row wrap class="pl-3 pr-1 text-left">
              <v-flex>
                <div class="pt-2" style="font-family: Roboto,sans-serif!important; font-size: 14px; color: #555555; line-height: 1.4em">Current Outstanding Open Ticket Trend for Last 6 Months</div>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
  </v-flex>
</v-layout>
</v-flex>
</v-layout>
</v-card-text>
</v-card>
</v-layout>
</v-col>
</v-row>

<v-container fluid class="py-2 px-0" v-if="lAction === 'view-card'">
  <v-flex xs12 mx-auto v-if="lTAction !== 'Update'">
    <v-card>
      <v-card-title class="pa-2 primary--text grey lighten-4">
        <v-layout row wrap>
          <v-btn class="pt-3" small icon @click="goBack()"><v-icon>mdi-arrow-left</v-icon></v-btn>
          <v-flex>{{ metricsHead + ' (' + lBbSupport.dep_pair.dept_name + ')' }}</v-flex>
        </v-layout>
        <v-flex xs6 style="margin-right: 130px;">
          <v-text-field
          append-icon="mdi-account-search"
          :placeholder="$vuetify.breakpoint.smAndUp?'Search by project name, status etc.':'Search'"
          hide-details
          v-model="search"
          outlined
          clearable
          dense
          ></v-text-field>
        </v-flex>
      </v-card-title>
      <v-flex xs12 mx-auto v-if="lTAction === 'view-update'">
        <v-layout class="pa-0">
          <!-- list view -->
          <v-flex xs12 mx-auto v-if="choosenView === 'list'">
            <v-card flat>
              <v-card-text class="pa-1">
                <v-data-table
                :headers="ticketHead"
                :items="ticketesList"
                hide-default-header
                dense
                :search="search"
                class="elevation-1"
                :footer-props="{'itemsPerPageOptions': [100, 50, 200, -1]}"
                :mobile-breakpoint="0">
                <template v-slot:header="{ props: { headers } }">
                  <thead>
                    <tr>
                      <th class="primary lighten-2 white--text" style="font-size: 13px; width: 50px; text-align: center">{{headers[0].text}}</th>
                      <th class="primary lighten-2 white--text" style="font-size: 13px; width: 150px; text-align: left">{{headers[1].text}}</th>
                      <th class="primary lighten-2 white--text" style="font-size: 13px; width: 150px; text-align: center">{{headers[2].text}}</th>
                      <th class="primary lighten-2 white--text" style="font-size: 13px; width: 150px; text-align: left">{{headers[3].text}}</th>
                      <th class="primary lighten-2 white--text" style="font-size: 13px; width: 150px; text-align: left">{{headers[4].text}}</th>
                      <th class="primary lighten-2 white--text" style="font-size: 13px; width: 350px; text-align: left">{{headers[5].text}}</th>
                      <th class="primary lighten-2 white--text" style="font-size: 13px; width: 180px; text-align: center">{{headers[6].text}}</th>
                      <th class="primary lighten-2 white--text" style="font-size: 13px; width: 180px; text-align: center">{{headers[7].text}}</th>
                      <th class="primary lighten-2 white--text" style="font-size: 13px; width: 100px; text-align: center">{{headers[8].text}}</th>
                      <th class="primary lighten-2 white--text" style="font-size: 13px; width: 30px; text-align: center">{{headers[9].text}}</th>
                      <th class="primary lighten-2 white--text" style="font-size: 13px; width: 30px; text-align: center">{{headers[10].text}}</th>
                    </tr>
                  </thead>
                </template>
                <template slot="item" slot-scope="props">
                  <tr>
                    <td style="text-align:center; font-size: 12px"><a style="text-decoration: underline;" class="primary--text" @click="prepareUpdate(props.item)">{{ props.item.ticket_id }}</a></td>
                    <td style="text-align:left; font-size: 12px">{{ props.item.proj_name }}</td>
                    <td style="text-align:left; font-size: 12px">{{ handy.formatDate(props.item.created_dt) }}</td>
                    <td style="text-align:left; font-size: 12px">{{ props.item.dept_name }}</td>
                    <td style="text-align:Left; font-size: 12px">{{ props.item.cat }}</td>
                    <td style="text-align:left; font-size: 12px">{{ props.item.description.substring(0,75) + '...'  }}</td>
                    <td style="text-align:left; font-size: 12px">{{ props.item.created_by_name }}</td>
                    <td style="text-align:left; font-size: 12px">{{ props.item.assigned_to ? props.item.assigned_to_name : 'NA' }}</td>
                    <td style="text-align:center; font-size: 12px">{{ props.item.status }}</td>
                    <td @click="loadTimeLine(props.item.ticket_id)">
                      <v-badge overlap color="info" v-if="props.item.tot_files">
                        <template v-slot:badge>
                          <span class="info"><strong>{{ props.item.tot_files }}</strong></span>
                        </template>
                        <v-icon small class="pa-2">mdi-attachment</v-icon>
                      </v-badge>
                    </td>
                    <td style="text-align:center; font-size: 12px">
                      <v-menu
                      :close-on-content-click="false"
                      top right class="mt-0">
                      <template v-slot:activator="{ on }">
                        <v-btn small icon v-on="on">
                          <v-icon>mdi-dots-vertical</v-icon>
                        </v-btn>
                      </template>
                      <!-- list of menuitems -->
                      <v-list class="py-0">
                        <!-- menu with submenus of status -->
                        <v-list-group
                        no-action
                        v-model="lSupport.statusList"
                        >
                        <template v-slot:activator>
                          <v-list-item class="px-0">
                            <v-list-item-avatar><v-icon>mdi-radar</v-icon></v-list-item-avatar>
                            <v-list-item-title>Change Status</v-list-item-title>
                          </v-list-item>
                        </template>
                        <v-list-item
                        v-if="((metricsHead === 'New Tickets' || metricsHead === 'Open Tickets' || metricsHead === 'Job-Done Tickets' || metricsHead === 'On-Hold Tickets' || metricsHead === 'UnAssigned Tickets') && props.item.status !== status && status !== 'New' && status !== 'Reopen') || (metricsHead === 'Closed Tickets' && props.item.status !== status && status === 'Reopen' || ((metricsHead === 'Total Tickets' || metricsHead === 'Closed SLA Missed') && props.item.status === 'Completed' && props.item.status !== status && status === 'Reopen') || ((metricsHead === 'Total Tickets' || metricsHead === 'Open SLA Missed' || metricsHead === 'Aged < 30 days' || metricsHead === 'Aged 30 - 60 days' || metricsHead === 'Aged 60 - 90 days' || metricsHead === 'Aged > 90 days') && props.item.status !== 'Completed' && props.item.status !== status && status !== 'Reopen' && status !== 'New'))"
                        v-for="(status, i) in statusList"
                        :key="i"
                        @click="prepareTicketStatus(props.item, status)"
                        >
                        <v-list-item-title>
                          {{ status }}
                        </v-list-item-title>
                      </v-list-item>
                    </v-list-group>
                    <v-divider></v-divider>
                    <v-list-item v-if="props.item.status !== 'Completed' && props.item.status !== 'Cancelled'" @click="prepareTicketStatus(props.item, 'Assigned')">
                      <v-list-item-avatar><v-icon>mdi-account-box</v-icon></v-list-item-avatar>
                      <v-list-item-title>Assign to</v-list-item-title>
                    </v-list-item>
                    <v-list-item v-if="props.item.status !== 'Completed' && props.item.status !== 'Cancelled'" @click="prepareTicketStatus(props.item, 'Comment')">
                      <v-list-item-avatar><v-icon>mdi-comment-text</v-icon></v-list-item-avatar>
                      <v-list-item-title>Comment</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="prepareUpdate(props.item)">
                      <v-list-item-avatar><v-icon>mdi-pencil</v-icon></v-list-item-avatar>
                      <v-list-item-title>Update</v-list-item-title>
                    </v-list-item>
                    <v-divider></v-divider>
                    <v-list-item @click="loadTimeLine(props.item.ticket_id)">
                      <v-list-item-avatar><v-icon>mdi-chart-line-variant</v-icon></v-list-item-avatar>
                      <v-list-item-title>Timeline</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </v-flex>
  <!-- card view -->
  <v-flex xs12 sm7 mx-auto v-if="choosenView === 'card'">
    <v-card flat>
      <v-card-text class="pt-3">
        <v-data-iterator
        :items="ticketesList"
        disable-pagination
        :search="search"
        hide-default-footer>
        <template v-slot:item="props">
          <v-layout>
            <v-flex xs12 class="pb-2">
              <v-card class="grey lighten-4">
                <v-card-text class="py-0">
                  <v-layout row wrap>
                    <v-flex xs10 sm11>
                      <div class="pt-3 subheading">
                        <b>{{ props.item.dept_name + ' - ' + props.item.cat}}</b>
                      </div>
                    </v-flex>
                    <v-flex xs2 sm1 class="pa-0">
                      <v-menu
                      :close-on-content-click="false"
                      top right class="mt-0">
                      <template v-slot:activator="{ on }">
                        <v-btn icon v-on="on">
                          <v-icon>mdi-dots-vertical</v-icon>
                        </v-btn>
                      </template>
                      <v-list class="py-0">
                        <!-- menu with submenus of status -->
                        <v-list-group
                        no-action
                        v-model="lSupport.statusList"
                        >
                        <template v-slot:activator>
                          <v-list-item class="px-0">
                            <v-list-item-avatar><v-icon>mdi-radar</v-icon></v-list-item-avatar>
                            <v-list-item-title>Change Status</v-list-item-title>
                          </v-list-item>
                        </template>
                        <v-list-item
                        v-if="((metricsHead === 'New Tickets' || metricsHead === 'Open Tickets' || metricsHead === 'Job-Done Tickets' || metricsHead === 'On-Hold Tickets' || metricsHead === 'UnAssigned Tickets') && props.item.status !== status && status !== 'New' && status !== 'Reopen') || (metricsHead === 'Closed Tickets' && props.item.status !== status && status === 'Reopen' || ((metricsHead === 'Total Tickets' || metricsHead === 'Closed SLA Missed') && props.item.status === 'Completed' && props.item.status !== status && status === 'Reopen') || ((metricsHead === 'Total Tickets' || metricsHead === 'Open SLA Missed' || metricsHead === 'Aged < 30 days' || metricsHead === 'Aged 30 - 60 days' || metricsHead === 'Aged 60 - 90 days' || metricsHead === 'Aged > 90 days') && props.item.status !== 'Completed' && props.item.status !== status && status !== 'Reopen' && status !== 'New'))"
                        v-for="(status, i) in statusList"
                        :key="i"
                        @click="prepareTicketStatus(props.item, status)"
                        >
                        <v-list-item-title>
                          {{ status }}
                        </v-list-item-title>
                      </v-list-item>
                    </v-list-group>
                    <v-divider></v-divider>
                    <v-list-item v-if="props.item.task_status !== 'Completed' && props.item.status !== 'Cancelled'" @click="prepareTicketStatus(props.item, 'Assigned')">
                      <v-list-item-avatar><v-icon>mdi-account-box</v-icon></v-list-item-avatar>
                      <v-list-item-title>Assign to</v-list-item-title>
                    </v-list-item>
                    <v-list-item v-if="props.item.status !== 'Completed' && props.item.status !== 'Cancelled'" @click="prepareTicketStatus(props.item, 'Comment')">
                      <v-list-item-avatar><v-icon>mdi-comment-text</v-icon></v-list-item-avatar>
                      <v-list-item-title>Comment</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="prepareUpdate(props.item)">
                      <v-list-item-avatar><v-icon>mdi-pencil</v-icon></v-list-item-avatar>
                      <v-list-item-title>Update</v-list-item-title>
                    </v-list-item>
                    <v-divider></v-divider>
                    <v-list-item @click="loadTimeLine(props.item.ticket_id)">
                      <v-list-item-avatar><v-icon>mdi-chart-line-variant</v-icon></v-list-item-avatar>
                      <v-list-item-title>Timeline</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </v-flex>
              <v-flex xs12>
                <div class="pb-2">
                  {{ props.item.description.substring(0,150) + '...' }}
                </div>
                <v-divider></v-divider>
              </v-flex>
              <v-flex xs12>
                <v-layout row wrap>
                  <v-flex xs6>
                    <v-layout row wrap>
                      <v-flex xs3 sm2>
                        <v-avatar size="24px" slot="activator" class="pt-0">
                          <img :src="handy.loadImg(props.item.created_avatar_url, true)"/>
                        </v-avatar>
                      </v-flex>
                      <v-flex xs9 sm10 class="caption">
                        <div class="primary--text"><strong>Created by</strong></div>
                        <div>{{ props.item.created_by_name }}</div>
                        <div>{{ handy.formatDate(props.item.created_dt) + ' ' + handy.getTime12Hrs(props.item.created_dt) }}</div>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex xs6>
                    <v-layout row wrap>
                      <v-flex xs3 sm2>
                        <v-avatar size="24px" slot="activator" class="pt-0">
                          <img v-if="props.item.assigned_to" :src="handy.loadImg(props.item.assigned_avatar_url, true)"/>
                          <v-icon class="grey" v-else>mdi-account</v-icon>
                        </v-avatar>
                      </v-flex>
                      <v-flex xs9 sm10 class="caption">
                        <div class="primary--text"><strong>Assigned to</strong></div>
                        <div v-if="props.item.assigned_to">
                          <div>{{ props.item.assigned_to_name }}</div>
                          <div v-if="props.item.assigned_dt">{{ handy.formatDate(props.item.assigned_dt) + ' ' + handy.getTime12Hrs(props.item.assigned_dt) }}</div>
                        </div>
                        <div v-else>NA</div>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex xs12 class="subheading">
                    <v-divider class="pt-1"></v-divider>
                    <v-layout row wrap>
                      <v-flex xs5>
                        <div class="pa-1" :class="props.item.status === 'New' ? 'grey--text' : (props.item.status === 'In Progress' ? 'accent--text' : (props.item.status === 'Completed' ? 'success--text' : 'error--text'))">
                          <span class="primary--text"> Status: </span> <span style="font-weight: bold"> {{ props.item.status }} </span>
                        </div>
                      </v-flex>
                      <v-flex xs5 style="font-size: 14px;">
                        <div class="pa-1">
                          <span class="primary--text"> Priority: </span> <span class="info--text" style="font-weight: bold"> {{ props.item.priority }} </span>
                        </div>
                      </v-flex>
                      <v-flex xs2 class="pa-1" v-if="props.item.tot_files" @click="loadTimeLine(props.item.ticket_id)">
                        <v-badge overlap color="info">
                          <template v-slot:badge>
                            <span class="info"><strong>{{ props.item.tot_files }}</strong></span>
                          </template>
                          <v-icon small class="pa-2">mdi-attachment</v-icon>
                        </v-badge>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </template>
</v-data-iterator>
</v-card-text>
</v-card>
</v-flex>
</v-layout>
<v-speed-dial :direction="$vuetify.breakpoint.smAndDown ? 'bottom' : 'left'" v-model="calFab"
style="position:fixed; top:70px; right:20px;">
<template v-slot:activator>
  <v-btn x-small slot="activator" v-model="calFab" fab color="accent">
    <v-icon small v-if="calFab">mdi-close</v-icon>
    <v-icon small v-else>mdi-eye</v-icon>
  </v-btn>
</template>

<!-- card view -->
<v-tooltip top>
  <template v-slot:activator="{ on }">
    <v-btn class="mr-1" fab x-small v-on="on"
    :color="choosenView === 'card' ? 'info' : ''"
    @click.native="changeView('card')">
    <v-icon small>mdi-image-filter-frames</v-icon>
  </v-btn>
</template>
<span>Card view</span>
</v-tooltip>

<!-- List view -->
<v-tooltip top>
  <template v-slot:activator="{ on }">
    <v-btn class="ma-1" fab x-small v-on="on"
    :color="choosenView === 'list' ? 'info' : ''"
    @click.native="changeView('list')">
    <v-icon small>mdi-format-list-bulleted</v-icon>
  </v-btn>
</template>
<span>List view</span>
</v-tooltip>
</v-speed-dial>

<!-- filter btn -->
<v-btn small
:style="'position:fixed; ' + ($vuetify.breakpoint.smAndDown?'bottom:15px; left:35px;':'bottom:15px; left:305px;')"
dark fab fixed
color="accent black--text"
@click.native="prepareFilter()">
<v-badge overlap color="info">
  <template v-slot:badge v-if="enabledFilter === true">
    <v-icon class="caption">mdi-check</v-icon>
  </template>
  <v-icon class="pa-2">mdi-filter-variant</v-icon>
</v-badge>
</v-btn>
</v-flex>
</v-card>
</v-flex>
<!-- Update ticket -->
<v-container grid-list-md v-if="lTAction === 'Update'">
  <v-layout row wrap>
    <v-flex xs12>
      <v-form ref="sForm" @submit.prevent="saveTicket(lTAction)">
        <v-card flat>
          <v-flex xs12 sm9 mx-auto>
            <v-card-title class="title pa-0 ml-3">
              {{ handy.startWithUpper(lTAction) + ' Ticket' }}
            </v-card-title>
            <v-card-text class="pa-1">
              <v-layout row wrap class="pa-0">
                <v-flex xs12>
                  <v-alert class="primary lighten-5">
                    <v-layout row wrap class="pa-0">
                      <v-flex xs4>
                        <div class="black--text font-weight-bold" style="font-size: 18px;">Ticket No: {{lSupport.ticket_id}}</div>
                      </v-flex>
                      <v-flex xs8>
                        <div class="black--text font-weight-bold" style="font-size: 18px;">Project Name: {{lSupport.proj_name}}</div>
                      </v-flex>
                    </v-layout>
                  </v-alert>
                </v-flex>
                <v-flex xs12 style="margin-top: -15px;">
                  <v-alert class="info lighten-2">
                    <span class="subtitle-1"><b> Description: </b> {{ lSupport.description }}</span>
                  </v-alert>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs5>
                  <v-select
                  v-model="lSupport.dep_pair"
                  :items="departmentList"
                  label="Department"
                  item-value="dept_id"
                  item-text="dept_name"
                  :rules="[rules.required]"
                  hide-details
                  return-object
                  @input="loadCategories(lSupport.dep_pair)"
                  ></v-select>
                </v-flex>
                <v-flex xs1 class="pb-2">
                  <v-btn fab small class="accent" @click="prepareDept"><v-icon>mdi-plus</v-icon></v-btn>
                </v-flex>
                <v-flex xs5>
                  <v-select
                  v-model="lSupport.cat_pair"
                  label="Category"
                  :items="catList"
                  item-value="cat_id"
                  item-text="cat"
                  :rules="[rules.required]"
                  hide-details
                  return-object
                  @input="loadSubCatList(lSupport.cat_pair)"
                  ></v-select>
                </v-flex>
                <v-flex xs1 class="pb-2">
                  <v-btn fab small class="accent" @click="prepareCategory"><v-icon>mdi-plus</v-icon></v-btn>
                </v-flex>
                <v-flex xs5>
                  <v-select
                  v-model="lSupport.sub_cat_pair"
                  label="Sub Category"
                  :items="subCatList"
                  item-value="sub_cat_id"
                  item-text="sub_cat"
                  return-object
                  hide-details
                  @input="loadSubCatList(lSupport.sub_cat_pair)"
                  ></v-select>
                </v-flex>
                <v-flex xs1 class="pb-2">
                  <v-btn fab small class="accent" @click="prepareSubCategory"><v-icon>mdi-plus</v-icon></v-btn>
                </v-flex>
                <v-flex xs6 v-if="lSupport.sub_cat_pair.sub_cat === 'Others'">
                  <v-text-field
                  v-model="lSupport.others"
                  label="Others"
                  hide-details
                  maxlength="50"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-layout row wrap>
                    <v-flex xs6>
                      <v-select
                      v-model="lSupport.assigned_to_pair"
                      :items="assignUserList"
                      label="Assigned to"
                      item-value="emp_id"
                      item-text="emp_name_with_id"
                      return-object
                      hide-details
                      :disabled="lSupport.status === 'Completed' || lSupport.status === 'Cancelled'"
                      @input="viewAssignComments()"
                      ></v-select>
                    </v-flex>
                    <v-flex xs6 class="pt-2" v-if="showAssign">
                      <v-textarea
                      v-model="lSupport.assign_comments"
                      label="Assignee Comments"
                      rows="1"
                      hide-details
                      maxlength="3000"
                      outlined
                      ></v-textarea>
                    </v-flex>
                    <v-flex xs12>
                      <v-layout row wrap>
                        <v-flex xs6>
                          <v-select
                          v-model="lSupport.priority_pair"
                          :items="priorityList"
                          label="Priority"
                          item-value="priority_id"
                          item-text="priority"
                          return-object
                          hide-details
                          :disabled="lSupport.status === 'Completed' || lSupport.status === 'Cancelled'"
                          ></v-select>
                        </v-flex>
                        <v-flex xs6>
                          <v-select
                          v-model="lSupport.status"
                          :items="['New', 'In Progress', 'On-Hold', 'Need More Info.', 'Completed', 'Cancelled', 'Reopen']"
                          label="Status"
                          hide-details
                          :disabled="lTAction === 'Update'"
                          ></v-select>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs12 class="pt-2">
                  <v-textarea
                  v-model="lSupport.description"
                  label="Description"
                  rows="2"
                  :rules="[rules.required]"
                  hide-details
                  maxlength="3000"
                  outlined
                  ></v-textarea>
                </v-flex>
                <v-flex xs6>
                  <v-dialog ref="planStartDt"
                  persistent v-model="planStartDt"
                  max-width="290px"
                  :return-value.sync="lSupport.planned_start_dt"
                  >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                    slot="activator" label="Plan Start Date"
                    v-model="lSupport.planned_start_dt"
                    append-icon="mdi-calendar-today"
                    readonly clearable
                    v-on="on"
                    hide-details
                    required
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="lSupport.planned_start_dt" scrollable
                  first-day-of-week="1"
                  >
                  <v-spacer></v-spacer>
                  <v-btn small @click="planStartDt = false">Cancel</v-btn>
                  <v-btn small color="accent" @click="$refs.planStartDt.save(lSupport.planned_start_dt)">OK</v-btn>
                </v-date-picker>
              </v-dialog>
            </v-flex>
            <v-flex xs6>
              <v-dialog ref="planEndDt"
              persistent v-model="planEndDt"
              max-width="290px"
              :return-value.sync="lSupport.planned_end_dt"
              >
              <template v-slot:activator="{ on }">
                <v-text-field
                slot="activator" label="Plan End Date"
                v-model="lSupport.planned_end_dt"
                append-icon="mdi-calendar-today"
                readonly clearable
                hide-details
                v-on="on"
                required
                ></v-text-field>
              </template>
              <v-date-picker v-model="lSupport.planned_end_dt" scrollable
              :min="lSupport.start_dt" first-day-of-week="1"
              >
              <v-spacer></v-spacer>
              <v-btn small @click="planEndDt = false">Cancel</v-btn>
              <v-btn small color="accent" @click="$refs.planEndDt.save(lSupport.planned_end_dt)">OK</v-btn>
            </v-date-picker>
          </v-dialog>
        </v-flex>
        <v-flex xs4>
          <v-dialog ref="actStartDt"
          persistent v-model="actStartDt"
          lazy max-width="290px"
          :return-value.sync="lSupport.act_start_dt"
          >
          <template v-slot:activator="{ on }">
            <v-text-field
            slot="activator" label="Actual Start Date"
            v-model="lSupport.act_start_dt"
            append-icon="mdi-calendar-today"
            disabled
            readonly clearable
            hide-details
            required
            v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker v-model="lSupport.act_start_dt" scrollable
          first-day-of-week="1"
          >
          <v-spacer></v-spacer>
          <v-btn flat @click="actStartDt = false">Cancel</v-btn>
          <v-btn flat color="accent" @click="$refs.actStartDt.save(lSupport.act_start_dt)">OK</v-btn>
        </v-date-picker>
      </v-dialog>
    </v-flex>
    <v-flex xs4>
      <v-dialog ref="actEndDt"
      persistent v-model="actEndDt"
      lazy max-width="290px"
      :return-value.sync="lSupport.act_end_dt"
      >
      <template v-slot:activator="{ on }">
        <v-text-field
        slot="activator" label="Actual End Date"
        v-model="lSupport.act_end_dt"
        disabled
        append-icon="mdi-calendar-today"
        readonly clearable
        hide-details
        required
        v-on="on"
        ></v-text-field>
      </template>
      <v-date-picker v-model="lSupport.act_end_dt" scrollable
      first-day-of-week="1"
      >
      <v-spacer></v-spacer>
      <v-btn flat @click="actEndDt = false">Cancel</v-btn>
      <v-btn flat color="accent" @click="$refs.actEndDt.save(lSupport.act_end_dt)">OK</v-btn>
    </v-date-picker>
  </v-dialog>
</v-flex>
<v-flex xs4>
  <v-dialog ref="jobDoneDt"
  persistent v-model="jobDoneDt"
  lazy max-width="290px"
  :return-value.sync="lSupport.job_done_dt"
  >
  <template v-slot:activator="{ on }">
    <v-text-field
    slot="activator" label="Job Done Date"
    v-model="lSupport.job_done_dt"
    append-icon="mdi-calendar-today"
    disabled
    readonly clearable
    hide-details
    required
    v-on="on"
    ></v-text-field>
  </template>
  <v-date-picker v-model="lSupport.job_done_dt" scrollable
  first-day-of-week="1"
  >
  <v-spacer></v-spacer>
  <v-btn flat @click="jobDoneDt = false">Cancel</v-btn>
  <v-btn flat color="accent" @click="$refs.jobDoneDt.save(lSupport.job_done_dt)">OK</v-btn>
</v-date-picker>
</v-dialog>
</v-flex>
<v-flex xs12>
  <input style="display:none" type="file" ref="fileInput"
  accept=".xls, .xlsx, .pdf, .doc, .docx, image/png, image/gif, image/jpeg" multiple @change="loadFilesFromFileBrowser(lSupport)"/>
  <v-btn @click="pickFile" icon><v-icon>mdi-attachment</v-icon></v-btn>
  <span v-if="lSupport.files && lSupport.files.filter(rec => rec.is_selected).length > 0">
    <span v-for="(file, index) in lSupport.files.filter(rec => rec.is_selected)" :key="index">
      <v-chip v-model="file.is_selected" @click:close="removeSelectedFile(file)" close>
        <span v-if="!file.is_changed">
          <a :href="file.file_url" download style="text-decoration: none;">
            <v-btn small icon class="ml-0 info grey--text text--lighten-4">
              <v-icon small>mdi-download</v-icon>
            </v-btn>
          </a>
        </span>
        <span style="font-size: 12px;" class="ml-2">{{ file.file_name }}</span>
      </v-chip>
    </span>
  </span>
  <span v-else class="caption">Attachment if any (upto 20MB)</span>
</v-flex>
</v-layout>
</v-card-text>
<v-card-actions class="pt-3">
  <v-layout row wrap>
    <v-spacer></v-spacer>
    <v-btn @click="cancelSaveChanges">Cancel</v-btn>
    <v-btn type="submit" color="accent black--text" :disabled="beingSaved || lSupport.status === 'Completed' || lSupport.status === 'Cancelled'">Save</v-btn>
  </v-layout>
</v-card-actions>
</v-flex>
</v-card>
</v-form>
</v-flex>
</v-layout>
</v-container>

<!-- 7. showing departmentList -->
<v-dialog v-model="showDept" persistent max-width="400px">
  <v-form>
    <v-card flat v-if="lDAction === 'view'" scrollable>
      <v-card-title class="title grey lighten-4 py-0">
        Department List
        <v-spacer></v-spacer>
        <v-btn small icon @click.stop="showDept = false"><v-icon>mdi-close</v-icon></v-btn>
        <v-flex xs12 class="ml-0">
          <v-btn color="accent" small class="mb-0" @click="createDept">Add New</v-btn>
        </v-flex>
      </v-card-title>
      <v-card-text class="pa-0">
        <v-flex xs12 sm9 md12 class="mx-auto">
          <v-data-table
          :headers="deptHead"
          :items="departmentList"
          hide-default-footer
          :mobile-breakpoint="0"
          disable-pagination
          disable-sort
          class="elevation-1">
          <template slot="item" slot-scope="props">
            <tr @click="prepareEditDept(props.item)">
              <td>{{ props.item.dept_name }}</td>
              <td>{{ props.item.dept_email_id }}</td>
            </tr>
          </template>
        </v-data-table>
      </v-flex>
    </v-card-text>
  </v-card>

  <!-- 8. create / edit dept -->
  <v-container v-if="lDAction === 'create' || lDAction === 'update'" class="pa-0" fluid grid-list-md>
    <v-form ref="acForm" @submit.prevent="saveDept(lDAction)">
      <v-card flat class="pa-0">
        <v-card-title class="title pb-0">
          {{ handy.startWithUpper(lDAction) }} department
        </v-card-title>
        <v-card-text>
          <v-flex xs12>
            <v-text-field
            v-model="lDept.dept_name"
            label="Department name"
            :rules="[rules.required]"
            hide-details
            maxlength="100">
          </v-text-field>
        </v-flex>
        <v-flex xs12>
          <v-text-field
          v-model="lDept.dept_email_id"
          label="Departments email id's"
          placeholder="Add Contact email with comma seperated"
          hide-details
          maxlength="200"
          ></v-text-field>
        </v-flex>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click.stop="cancelChangesDept">Cancel</v-btn>
        <v-btn v-if="lDAction === 'update'" :disabled="beingSaved" @click="deleteDept(lDept)">delete</v-btn>
        <v-btn type="submit" color="accent" :disabled="beingSaved">Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-form>
</v-container>
</v-form>
</v-dialog>

<!-- 7. showing category -->
<v-dialog v-model="showCat" persistent max-width="400px">
  <v-form>
    <v-card flat v-if="lMAction === 'view'" scrollable>
      <v-card-title class="title grey lighten-4 py-0">
        Categories List
        <v-spacer></v-spacer>
        <v-btn small icon @click.stop="showCat = false"><v-icon>mdi-close</v-icon></v-btn>
        <v-flex xs12 class="ml-0">
          <v-btn color="accent" small class="mb-0" @click="createCat">Add New</v-btn>
        </v-flex>
      </v-card-title>
      <v-card-text class="pa-0">
        <v-flex xs12 sm9 md12 class="mx-auto">
          <v-data-table
          :headers="catHead"
          :items="catList"
          hide-default-footer
          :mobile-breakpoint="0"
          disable-pagination
          class="elevation-1">
          <template slot="item" slot-scope="props">
            <tr @click="prepareEditCat(props.item)">
              <td>{{ props.item.cat }}</td>
            </tr>
          </template>
        </v-data-table>
      </v-flex>
    </v-card-text>
  </v-card>

  <!-- 8. create / edit category -->
  <v-container v-if="lMAction === 'create' || lMAction === 'update'" class="pa-0" fluid grid-list-md>
    <v-form ref="acForm" @submit.prevent="saveCat(lMAction)">
      <v-card flat class="pa-0">
        <v-card-title class="title pb-0">
          {{ handy.startWithUpper(lMAction) }} Category
        </v-card-title>
        <v-card-text>
          <v-text-field
          v-model="lCat.cat"
          label="Category name"
          :rules="[rules.required]"
          hide-details
          maxlength="100">
        </v-text-field>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click.stop="cancelChangesCat">Cancel</v-btn>
        <v-btn v-if="lMAction === 'update'" :disabled="beingSaved" @click="deleteCat(lCat)">delete</v-btn>
        <v-btn type="submit" color="accent" :disabled="beingSaved">Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-form>
</v-container>
</v-form>
</v-dialog>

<!-- 7. showing sub category -->
<v-dialog v-model="showSubCat" persistent max-width="400px">
  <v-form>
    <v-card flat v-if="lSAction === 'view'" scrollable>
      <v-card-title class="title grey lighten-4 py-0">
        Sub Categories List
        <v-spacer></v-spacer>
        <v-btn small icon @click.stop="showSubCat = false"><v-icon>mdi-close</v-icon></v-btn>
        <v-flex xs6 class="ml-0">
          <v-btn color="accent" small class="mb-0" @click="createSubCat">Add New</v-btn>
        </v-flex>
      </v-card-title>
      <v-card-text class="pa-0">
        <v-flex xs12 sm9 md12 class="mx-auto">
          <v-data-table
          :headers="subCatHead"
          :items="subCatList"
          :mobile-breakpoint="0"
          hide-default-footer
          disable-pagination
          class="elevation-1">
          <template slot="item" slot-scope="props">
            <tr @click="prepareEditSubCat(props.item)">
              <td>{{ props.item.sub_cat }}</td>
            </tr>
          </template>
        </v-data-table>
      </v-flex>
    </v-card-text>
  </v-card>

  <!-- 8. create / edit category -->
  <v-container v-if="lSAction === 'create' || lSAction === 'update'" class="pa-0" fluid grid-list-md>
    <v-form ref="acForm" @submit.prevent="saveSubCat(lSAction)">
      <v-card flat class="pa-0">
        <v-card-title class="title pb-0">
          {{ handy.startWithUpper(lSAction) }} Sub Category
        </v-card-title>
        <v-card-text>
          <v-text-field
          v-model="lSubCat.sub_cat"
          label="Sub category name"
          :rules="[rules.required]"
          hide-details
          maxlength="100">
        </v-text-field>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click.stop="cancelChangesSubCat">Cancel</v-btn>
        <v-btn v-if="lSAction === 'update'" :disabled="beingSaved" @click="deleteSubCat(lSubCat)">delete</v-btn>
        <v-btn type="submit" color="accent" :disabled="beingSaved">Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-form>
</v-container>
</v-form>
</v-dialog>

<!-- 2. Give notes based on your actions(comment, need more info., on-hold, completed) -->
<v-dialog v-model="showDlgStatus" persistent max-width="500px">
  <v-card>
    <v-card-title class="pa-2 ml-2 title">
      {{ lTicketStatus.action === 'Comment' ? 'Add comment' : lTicketStatus.action === 'Assigned' ? 'Assign To' : 'Add comments for ' + lTicketStatus.action }}
    </v-card-title>
    <v-card-text class="black--text">
      <v-flex xs12 v-if="lTicketStatus.action === 'Assigned'">
        <v-select
        v-model="lTicketStatus.assigned_to_pair"
        :items="assignUserList"
        label="Assigned to"
        item-value="emp_id"
        item-text="emp_name_with_id"
        return-object
        hide-details
        ></v-select>
      </v-flex>
      <v-flex xs12 class="pt-2 pl-3" v-if="lTicketStatus.action === 'Completed'">
        <v-layout row wrap>
          <v-flex xs7 sm5>
            <v-dialog ref="dlgEndDate"
            persistent v-model="dlgEndDate"
            max-width="290px"
            :return-value.sync="lTicketStatus.planned_end_dt"
            >
            <template v-slot:activator="{ on }">
              <v-text-field
              slot="activator" label="Completed date"
              v-model="lTicketStatus.planned_end_dt"
              append-icon="mdi-calendar-today"
              readonly clearable
              hide-details
              required
              v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker v-model="lTicketStatus.planned_end_dt" scrollable
            :max="today" first-day-of-week="1"
            >
            <v-spacer></v-spacer>
            <v-btn text @click="dlgEndDate = false">Cancel</v-btn>
            <v-btn text color="accent" @click="$refs.dlgEndDate.save(lTicketStatus.planned_end_dt)">OK</v-btn>
          </v-date-picker>
        </v-dialog>
      </v-flex>
    </v-layout>
  </v-flex>
  <v-flex xs12 class="pt-5">
    <v-textarea hide-details outlined
    :placeholder="placeHolder"
    rows="7"
    row-height="25"
    maxlength="250"
    v-model="lTicketStatus.notes"></v-textarea>
  </v-flex>
  <v-flex xs12 v-if="lTicketStatus.action === 'Comment' || lTicketStatus.action === 'Assigned'">
    <input style="display:none" type="file" ref="statusFileInput"
    accept=".xls, .xlsx, .pdf, .doc, .docx, image/png, image/gif, image/jpeg" multiple @change="loadFilesFromBrowser(lTicketStatus)"/>
    <v-btn icon @click="pickFile"><v-icon>mdi-attachment</v-icon></v-btn>
    <span v-if="lTicketStatus.files && lTicketStatus.files.filter(rec => rec.is_selected).length > 0">
      <span v-for="(file, index) in lTicketStatus.files.filter(rec => rec.is_selected)" :key="index">
        <v-chip v-model="file.is_selected" @input="$forceUpdate()" close>
          {{ file.file_name }}
          <span v-if="!file.is_changed">
            <a :href="file.file_url" download style="text-decoration: none;">
              <v-btn small icon class="ml-1 info grey--text text--lighten-4">
                <v-icon small>mdi-download</v-icon>
              </v-btn>
            </a>
          </span>
        </v-chip>
      </span>
    </span>
    <span v-else>Attachment(images, pdf, doc, word, excel) if any</span>
  </v-flex>
</v-card-text>
<v-card-actions>
  <v-spacer></v-spacer>
  <v-btn text @click.stop="showDlgStatus = false">cancel</v-btn>
  <v-btn text color="accent" @click="postTicketStatus()">submit</v-btn>
</v-card-actions>
</v-card>
</v-dialog>

<!-- 3. show Timeline for particular ticket_id -->
<v-dialog v-model="showTimeline" scrollable max-width="600px">
  <v-card>
    <v-card-title class="py-1 title primary white--text">
      <div>Timeline</div>
      <v-spacer></v-spacer>
      <v-btn small icon @click.stop="showTimeline = false"><v-icon>mdi-close</v-icon></v-btn>
    </v-card-title>
    <v-card-text class="pl-0 pr-4 py-3">
      <v-timeline dense class="pt-0">
        <v-timeline-item :class="n === lTimeLine.length-1 ? 'pb-0' : ''"
        v-for="(timeline, n) in lTimeLine"
        :key="n"
        small
        :id="'timeline_' + n"
        >
        <template v-slot:icon>
          <v-avatar>
            <img :src="handy.loadImg(timeline.created_avatar_url, true)">
          </v-avatar>
        </template>
        <v-card>
          <div v-if="timeline.action === 'Ticket Updated'">
            <v-card-title class="title pa-2">
              {{ timeline.action }}
            </v-card-title>
            <v-card-text class="pt-0 pb-2">
              <div v-if="timeline.notes !== ''">
                <div v-if="timeline.action === 'Ticket Updated'">
                  <div class="pb-1" v-if="timeline.assign_comments !== ''">
                    <b v-if="timeline.assign_comments !== ''">Assignee Comments: </b>{{ timeline.assign_comments }}
                  </div>
                  <div><b>Notes: </b>
                    <div v-for="(note, i) in timeline.timeLineNote" :key="i">
                      <span v-if="note">{{ i+1 + '. ' + note }}</span>
                    </div>
                  </div>
                </div>
                <div v-else class="pb-1">
                  <b>Notes: </b>{{ timeline.notes }}
                </div>
              </div>
              <div v-else>
                <div v-if="timeline.assign_comments !== ''"><b v-if="timeline.assign_comments !== ''">Assigned to: </b>{{ timeline.assigned_to_name }}</div>
                <div class="pb-1" v-if="timeline.assign_comments !== ''">
                  <b v-if="timeline.assign_comments !== ''">Assignee Comments: </b>{{ timeline.assign_comments }}
                </div>
              </div>
            </v-card-text>
          </div>
          <div v-else>
            <v-card-title class="title pa-2">
              {{ timeline.action }}
            </v-card-title>
            <v-card-text class="pt-0 pb-2">
              <div v-if="timeline.action === 'Assigned'"><b>Assigned to: </b> {{timeline.assigned_to_name }}</div>
              <div v-if="timeline.action === 'Ticket Created'"><b>Description: </b>{{ timeline.notes }}</div>
              <div v-else><b>Comments: </b>{{ timeline.notes }}</div>
            </v-card-text>
          </div>
          <v-container grid-list-sm class="pa-0" v-if="lTimeLine.attachImages && lTimeLine.attachImages.filter(rec => rec.action === timeline.action && timeline.ticket_det_id === rec.ticket_det_id).length ||
          lTimeLine.attachFile && lTimeLine.attachFile.filter(rec => rec.action === timeline.action && timeline.ticket_det_id === rec.ticket_det_id)">
          <v-layout row wrap>
            <v-flex xs12 sm10 v-if="lTimeLine.attachImages.length && lTimeLine.attachImages.filter(rec => rec.action === timeline.action).length > 0">
              <v-flex xs12 v-if="(lTimeLine.attachImages.filter(rec => rec.action === timeline.action && rec.ticket_det_id === timeline.ticket_det_id).length > 0) && (lTimeLine.attachFile.filter(rec => rec.action === timeline.action && rec.ticket_det_id === timeline.ticket_det_id).length > 0)">
                <v-layout row wrap class="caption grey--text mb-2">
                  <v-flex xs6 sm8 class="ml-1">
                    Image Attachments
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs12>
                <div v-viewer="options" class="clearfix">
                  <template v-for="(file, index) in lTimeLine.attachImages">
                    <span v-if="(file.action === timeline.action && file.ticket_det_id === timeline.ticket_det_id)">
                      <img width="80px" :src="file.file_url" :key="index" class="ma-1" style="display: inline-block; cursor: pointer;">
                    </span>
                  </template>
                </div>
              </v-flex>
            </v-flex>
            <v-flex xs12 sm10 v-if="lTimeLine.attachFile.length && lTimeLine.attachFile.filter(rec => rec.action === timeline.action).length > 0">
              <v-flex xs12 v-if="(lTimeLine.attachImages.filter(rec => rec.action === timeline.action && rec.ticket_det_id === timeline.ticket_det_id).length > 0) && (lTimeLine.attachFile.filter(rec => rec.action === timeline.action && rec.ticket_det_id === timeline.ticket_det_id).length > 0)">
                <v-layout row wrap class="caption grey--text mb-2">
                  <v-flex xs6 sm8 class="ml-1">
                    Other Attachments
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs12>
                <span v-for="(file, index) in lTimeLine.attachFile" :key="index">
                  <v-chip v-if="(file.action === timeline.action && file.ticket_det_id === timeline.ticket_det_id)">
                    <a :href="file.file_url" download style="text-decoration: none;">
                      <v-btn small icon class="mr-1 info grey--text text--lighten-4">
                        <v-icon small>mdi-download</v-icon>
                      </v-btn>
                    </a>
                    <span style="font-size: 12px;">{{file.file_name}}</span>
                  </v-chip>
                </span>
              </v-flex>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-container>
      <v-divider></v-divider>
      <v-card-actions class="caption pa-2">
        {{ timeline.created_by_name }}
        <span class="grey--text pl-2">{{ handy.formatDate(timeline.action_dt) + ' ' + handy.getTime12Hrs(timeline.action_dt) }}</span>
      </v-card-actions>
    </v-card>
  </v-timeline-item>
</v-timeline>
</v-card-text>
</v-card>
</v-dialog>

<!-- 4. show filter category in bottom sheet -->
<v-bottom-sheet inset class="caption" v-model="showFilter" max-width="500px">
  <v-card>
    <v-card-text class="pa-4">
      <v-container grid-list-md class="pa-0">
        <v-layout row wrap>
          <v-flex xs12>
            <div class="caption primary--text">Filter by attributes</div>
          </v-flex>
          <v-flex xs12>
            <v-select
            v-model="filterList.comm_id_list"
            :items="commList"
            label="Community"
            item-text="comm_name"
            item-value="comm_id"
            hide-details
            small-chips
            clearable
            dense
            multiple
            return-object
            @input="loadCreatedUserList(filterList.comm_id_list)"
            ></v-select>
          </v-flex>
          <v-flex xs6>
            <v-select
            v-model="filterList.ticket_dept_list"
            :items="departmentList"
            label="Department"
            item-text="dept_name"
            item-value="dept_id"
            small-chips
            clearable
            dense
            hide-details
            return-object
            @input="loadCategories(filterList.ticket_dept_list)"
            ></v-select>
          </v-flex>
          <v-flex xs6>
            <v-select
            v-model="filterList.ticket_cat_list"
            :items="catList"
            label="Category"
            item-text="cat"
            item-value="cat_id"
            hide-details
            small-chips
            clearable
            dense
            multiple
            ></v-select>
          </v-flex>
          <v-flex xs6>
            <v-select
            v-model="filterList.priority_list"
            label="Priority"
            :items="priorityList"
            item-text="priority"
            item-value="priority_id"
            small-chips
            clearable
            dense
            multiple
            hide-details
            ></v-select>
          </v-flex>
          <v-flex xs6>
            <v-select
            v-model="filterList.ticket_status_list"
            label="Status"
            :items="filterStatus"
            small-chips
            clearable
            dense
            multiple
            hide-details
            ></v-select>
          </v-flex>
          <v-flex xs12>
            <div class="caption primary--text pt-3">Filter by people</div>
          </v-flex>
          <v-flex xs12>
            <v-select
            v-model="filterList.created_user_pair_list"
            label="Created by"
            :items="mcList"
            item-text="user_name"
            dense
            hide-details
            return-object
            ></v-select>
          </v-flex>
          <v-flex xs12>
            <v-select
            v-model="filterList.assigned_user_pair_list"
            :items="assignUserList"
            label="Assigned to"
            item-text="emp_name_with_id"
            dense
            hide-details
            return-object
            ></v-select>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-container>
</v-card-text>
<v-card-actions>
  <v-btn @click.stop="showFilter = false">Close</v-btn>
  <v-spacer></v-spacer>
  <v-btn @click="clearFilter">Clear all</v-btn>
  <v-btn color="accent" @click="applyFilter">Apply</v-btn>
</v-card-actions>
</v-card>
</v-bottom-sheet>
</v-container>
<!-- showing sla-->
<v-dialog v-model="showSla" scrollable max-width="550px">
  <v-card flat scrollable>
    <v-card-title class="title grey lighten-4 pa-2">
      SLA
      <v-spacer></v-spacer>
      <v-btn small icon @click.stop="showSla = false"><v-icon>mdi-close</v-icon></v-btn>
    </v-card-title>
    <v-card-text class="pa-1">
      <v-flex xs12 sm9 md12 class="mx-auto">
        <v-data-table
        :headers="slaHead"
        :items="tickeSlaHour"
        :mobile-breakpoint="0"
        hide-default-footer
        disable-pagination
        class="elevation-1">
        <template slot="item" slot-scope="props">
          <tr>
            <td>{{ props.item.priority }}</td>
            <td>{{ props.item.resolution_hrs }}</td>
            <td>{{ props.item.response_hrs }}</td>
            <td>
              <v-btn icon small><v-icon small @click="prepareUpdateSla(props.item)">mdi-pencil</v-icon></v-btn>
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-flex>
  </v-card-text>
</v-card>
</v-dialog>

<!-- edit sla -->
<v-dialog v-model="showSlaCreate" scrollable max-width="450px">
  <v-container class="pa-0" v-if="lSlAction === 'edit'" fluid grid-list-md>
    <v-form ref="acForm" @submit.prevent="saveChangesSla(lSlAction)">
      <v-card flat class="pa-0">
        <v-card-title class="title grey lighten-4 pb-0">
          Edit SLA
          <v-spacer></v-spacer>
          <v-btn small icon @click.stop="showSlaCreate = false"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-card-text>
          <v-flex xs6>
            <v-text-field
            v-model="lTicketSla.priority"
            label="Priority"
            :rules="[rules.required]"
            hide-details
            maxlength="25">
          </v-text-field>
        </v-flex>
        <v-flex xs6>
          <v-text-field
          v-model="lTicketSla.resolution_hrs"
          label="Resolution hrs"
          :rules="[rules.required]"
          hide-details
          maxlength="11">
        </v-text-field>
      </v-flex>
      <v-flex xs6>
        <v-text-field
        v-model="lTicketSla.response_hrs"
        label="Response hrs"
        :rules="[rules.required]"
        hide-details
        maxlength="11">
      </v-text-field>
    </v-flex>
  </v-card-text>
  <v-card-actions>
    <v-spacer></v-spacer>
    <v-btn type="submit" color="accent" :disabled="beingSaved">Save</v-btn>
  </v-card-actions>
</v-card>
</v-form>
</v-container>
</v-dialog>
<!-- snack bar for reporting -->
<v-snackbar :color="sbarCol" v-model="sbar"
:timeout="3000" multi-line><span class="mx-auto">{{ sbarMsg }}</span>
</v-snackbar>
</v-container>

</template>

<script>
import config from '@/config/app-cfg'
import handy from '@/utils/handy'
var Chart = require('chart.js')
import 'chartjs-plugin-datalabels'

export default {
  data () {
    return {
      sbarMsg: '',
      sbarCol: 'error',
      sbar: false,
      handy: handy,
      config: config,
      search: '',
      rules: handy.rules,
      dlgFromDate: false,
      dlgToDate: false,
      lDateFrom: '',
      lDateTo: '',
      chartDataForTotalTickets: [],
      chartDataForOpenVsClosedTickets: [],
      dashboardTicketDetail: [],
      dashboardAgedTicketCount: [],
      dashboardSLATicketCount: [],
      dashboardRespResolTime: [],
      loaded_date: '',
      departmentList: [],
      lBbSupport: {},
      ticketesList: [],
      metricsHead: '',
      metricDept: '',
      lAction: 'view',
      ticketHead: [
        { text: 'Ticket No', value: 'ticket_id', sortable: false },
        { text: 'Project Name', value: 'proj_name', sortable: false },
        { text: 'Created Date', value: 'created_dt', sortable: false },
        { text: 'Department', value: 'dept_name', sortable: false },
        { text: 'Category', value: 'cat', sortable: false },
        { text: 'Description', value: 'description', sortable: false },
        { text: 'Created By', value: 'created_by_name', sortable: false },
        { text: 'Assigned to', value: 'assigned_to_name', sortable: false },
        { text: 'Status', value: 'status', sortable: false },
        { text: 'Attach', sortable: false, value: 'attach' },
        { text: '', value: 'action', sortable: false}
      ],
      lSupport: {},
      statusList: ['New', 'In Progress', 'Need More Info.', 'On-Hold', 'Job-Done', 'Completed', 'Cancelled', 'Reopen'],
      lTicketStatus: [],
      planStartDt: false,
      planEndDt: false,
      actStartDt: false,
      actEndDt: false,
      jobDoneDt: false,
      beingSaved: false,
      catList: [],
      subCatList: [],
      assignUserList: [],
      showDlgStatus: false,
      dlgEndDate: false,
      placeHolder: '',
      lTimeLine: [],
      showTimeline: false,
      lMAction: '',
      lSAction: '',
      showCat: false,
      showSubCat: false,
      catHead: [
        { text: 'Category', value: 'cat' }
      ],
      subCatHead: [
        { text: 'Sub Category', value: 'sub_cat' }
      ],
      previousData: [],
      lTAction: 'view-update',
      choosenView: 'list',
      calFab: false,
      lDAction: '',
      showDept: false,
      lDept: '',
      deptHead: [
        { text: 'Department Name', value: 'dept_name' },
        { text: 'Email Id', value: 'dept_email_id' }
      ],
      showSla: false,
      lTicketSla: '',
      priorityList: [],
      tickeSlaHour: [],
      slaHead: [
        { text: 'Priority', value: 'priority' },
        { text: 'Resolution Hours', value: 'resolution_hrs' },
        { text: 'Response Hours', value: 'response_hrs' },
        { text: 'Action', value: 'action', sortable: false}
      ],
      lSlAction: '',
      showSlaCreate: false,
      options: {
        toolbar: true,
        url: 'data-source'
      },
      showAssign: false,
      UAction: false,
      enabledFilter: false,
      filterList: [],
      filterStatus: ['New', 'In Progress', 'Need More Info.', 'On-Hold', 'Job-Done', 'Cancelled', 'Completed', 'Reopen'],
      dlgFromDate: false,
      dlgToDate: false,
      showFilter: false,
      mcList: [],
      commList: []
    }
  },
  computed: {
    today: function () {
      return handy.formatDBDate(Date())
    }
  },
  // mounted () {
  //   this.loadDepartments()
  //   this.refreshDashBoard()
  // },
  created () {
    this.loadDepartments()
    this.lBbSupport.dep_pair = {dept_id: 0, dept_name: 'All Departments'}
    var curDate = new Date()
    this.lDateFrom = handy.formatDBDate(new Date(curDate.getFullYear(), curDate.getMonth() - 5, 1))
    this.lDateTo = handy.formatDBDate(new Date(curDate.getFullYear(), curDate.getMonth() + 1, 0))
    this.refreshDashBoard()
    this.filterList = this.getEmptyFilter()
  },
  methods: {
    msg (m, type = 0) {
      if (type === 0) {
        this.sbarCol = 'error'
      } else if (type === 1) {
        this.sbarCol = 'success'
      } else {
        this.sbarCol = 'info'
      }
      this.sbar = true
      this.sbarMsg = m
    },
    refreshDashBoard () {
      this.loadChartDataForCurOpenTicketsFor6Months()
      this.loadChartDataForRaisedVsClosedTicketsFor6Months()
      this.loadUpdatedDateTime()
      this.loadDashboardTicketCount()
      this.loadDashboardAgedTicketCount()
      this.loadDashboardSLATicketCount()
      this.loadDashboardRespResolTime()
    },
    loadUpdatedDateTime () {
      var curDate = new Date()
      this.loaded_date = handy.formatDisplayDateTime(curDate)
    },
    loadChartDataForCurOpenTicketsFor6Months () {
      var qry = {
        params: {
          dept_id: this.lBbSupport.dep_pair? this.lBbSupport.dep_pair.dept_id : null,
          vendor_id: config.VENDOR_ID
        }
      }
      this.loadUpdatedDateTime()
      this.axios.get(config.API_URL + '/getChartDataForCurOpenTicketsFor6Months/', qry)
      .then(response => {
        this.chartDataForTotalTickets = response.data
        document.getElementById('div_chartDataForCurOpenTicketsFor6Months').innerHTML = '<canvas id="chart_chartDataForCurOpenTicketsFor6Months"></canvas>'
        var canvas = document.getElementById('chart_chartDataForCurOpenTicketsFor6Months')
        var ctx = canvas.getContext('2d')
        ctx.canvas.height = 180
        // ctx.beginPath()
        // ctx.setLineDash([5, 10])
        // ctx.moveTo(0, 50)
        // ctx.lineTo(300, 50)
        // ctx.stroke()
        this.tmpChart = new Chart(ctx, {
          type: 'line',
          data: {
            labels: this.chartDataForTotalTickets.map(rec =>rec.monthyear),
            datasets: [{
              borderWidth: 3,
              backgroundColor: '#FFA726', //'#880E4F',
              borderColor: '#FFA726', // "rgba(219, 0, 0, 1)",
              data: this.chartDataForTotalTickets.map(rec =>rec.open_ticket),
              lineTension: 0,
              fill: false
            }]
          },
          options: {
            layout: {
              padding: 0
            },
            plugins: {
              datalabels: {
                formatter: function (value) {
                  return '' //return value || ''
                },
                color: '#ffffff', //'#880E4F',
                fontSize: 0,
              }
            },
            tooltips: {
              enabled: true,
              mode: 'label'
            },
            responsive: true,
            maintainAspectRatio: false,
            legend: {
              display: false,
              position: 'bottom',
              labels: {
                usePointStyle: true,
                fontSize: 11
              }
            },
            scales: {
              xAxes: [{
                ticks: {
                  display: true,
                  beginAtZero: true,
                  min: 0,
                  fontColor: '#ffffff'
                },
                grid: {
                  display: false,
                  offset: true
                },
                gridLines: {
                  lineWidth: 0.4,
                  display: true,
                  borderDash: [1, 2],
                  color: "white",
                  zeroLineColor: "#E91E63"
                }
              }],
              yAxes: [{
                ticks: {
                  display: true,
                  fontColor: '#ffffff',
                  beginAtZero: true,
                  min: 0
                },
                grid: {
                  display: false,
                  offset: true
                },
                gridLines: {
                  lineWidth: 0.8,
                  display: true,
                  borderDash: [1, 2],
                  color: "white",
                  zeroLineColor: "#ffffff",
                  zeroLineWidth: 0.2
                }
              }]
            },
            hover: {
              animationDuration: 0
            }
          }
        })
      })
      .catch(err => {
        this.msg(err)
      })
    },
    loadChartDataForRaisedVsClosedTicketsFor6Months () {
      var qry = {
        params: {
          dept_id: this.lBbSupport.dep_pair? this.lBbSupport.dep_pair.dept_id : null,
          vendor_id: config.VENDOR_ID
        }
      }
      this.loadUpdatedDateTime()
      this.axios.get(config.API_URL + '/getChartDataForRaisedVsClosedTickets/', qry)
      .then(response => {
        // clnsole.log(response.data)
        this.chartDataForOpenVsClosedTickets = response.data
        document.getElementById('div_chartDataForRaisedVsClosedTickets').innerHTML = '<canvas id="chart_chartDataForRaisedVsClosedTickets"></canvas>'
        var canvas = document.getElementById('chart_chartDataForRaisedVsClosedTickets')
        var ctx = canvas.getContext('2d')
        ctx.canvas.height = 180
        //ctx.beginPath()
        //ctx.setLineDash([5, 10])
        //ctx.moveTo(0, 50)
        //ctx.lineTo(300, 50)
        //ctx.stroke()
        this.tmpChart = new Chart(ctx, {
          type: 'line',
          data: {
            labels: this.chartDataForOpenVsClosedTickets.map(rec =>rec.monthyear),
            datasets: [{
              label: 'Total Raised',
              data: this.chartDataForOpenVsClosedTickets.map(rec =>rec.tot_ticket),
              borderWidth: 3,
              backgroundColor: '#FFA726', //'#EEEEEE',
              borderColor: '#FFA726', //"#BDBDBD",
              lineTension: 0,
              fill: false
            },
            {
              label: 'Closed Tickets',
              data: this.chartDataForOpenVsClosedTickets.map(rec =>rec.closed_ticket),
              borderWidth: 3,
              backgroundColor: '#9CCC65', //'#BDBDBD',
              borderColor: "#9CCC65",
              lineTension: 0,
              fill: false
            }]
          },
          options: {
            layout: {
              padding: 0
            },
            interaction: {
              mode: 'index',
              intersect: false,
            },
            stacked: false,
            plugins: {
              datalabels: {
                formatter: function (value) {
                  return '' //return 'value' || ''
                },
                color: '#000000',
                fontSize: 11,
              }
            },
            tooltips: {
              enabled: true,
              mode: 'label'
            },
            responsive: true,
            maintainAspectRatio: false,
            legend: {
              display: true,
              position: 'bottom',
              labels: {
                usePointStyle: false,
                fontColor: "white",
                fontSize: 11
              }
            },
            scales: {
              xAxes: [{
                ticks: {
                  display: true,
                  beginAtZero: true,
                  min: 0,
                  fontColor: '#ffffff'
                },
                grid: {
                  display: true,
                  offset: true
                },
                gridLines: {
                  lineWidth: 0.4,
                  display: true,
                  borderDash: [1, 2],
                  color: "white",
                  zeroLineColor: "#E91E63"
                }
              }],
              yAxes: [{
                ticks: {
                  display: true,
                  fontColor: '#ffffff',
                  beginAtZero: true,
                  min: 0
                },
                grid: {
                  display: true,
                  offset: true
                },
                gridLines: {
                  lineWidth: 1,
                  display: true,
                  borderDash: [1, 2],
                  color: "white",
                  zeroLineColor: "#ffffff",
                  zeroLineWidth: 0.2
                }
              }]
            },
            hover: {
              animationDuration: 0
            }
          }
        })
      })
      .catch(err => {
        this.msg(err)
      })
    },
    loadDashboardTicketCount () {
      if(this.lDateFrom != null && this.lDateTo === null) {
        this.lDateTo = this.lDateFrom
      }
      if(this.lDateTo != null && this.lDateFrom === null) {
        this.lDateFrom = this.lDateTo
      }
      var qry = {
        params: {
          from_date: this.lDateFrom + ' 00:00:00',
          to_date: this.lDateTo + ' 23:59:59',
          dept_id: this.lBbSupport.dep_pair? this.lBbSupport.dep_pair.dept_id : null,
          vendor_id: config.VENDOR_ID
        }
      }
      this.axios.get(config.API_URL + '/getDashboardTicketCount/', qry)
      .then(response => {
        this.dashboardTicketDetail = response.data
      })
      .catch(err => {
        this.msg(err, true)
      })
    },
    loadDashboardAgedTicketCount () {
      if(this.lDateFrom != null && this.lDateTo === null) {
        this.lDateTo = this.lDateFrom
      }
      if(this.lDateTo != null && this.lDateFrom === null) {
        this.lDateFrom = this.lDateTo
      }
      var qry = {
        params: {
          from_date: this.lDateFrom,
          to_date: this.lDateTo,
          dept_id: this.lBbSupport.dep_pair? this.lBbSupport.dep_pair.dept_id : null,
          vendor_id: config.VENDOR_ID
        }
      }
      this.axios.get(config.API_URL + '/getDashboardAgedTicketCount/', qry)
      .then(response => {
        this.dashboardAgedTicketCount = response.data
      })
      .catch(err => {
        this.msg(err, true)
      })
    },
    loadDashboardSLATicketCount () {
      if(this.lDateFrom != null && this.lDateTo === null) {
        this.lDateTo = this.lDateFrom
      }
      if(this.lDateTo != null && this.lDateFrom === null) {
        this.lDateFrom = this.lDateTo
      }
      var qry = {
        params: {
          from_date: this.lDateFrom,
          to_date: this.lDateTo,
          dept_id: this.lBbSupport.dep_pair? this.lBbSupport.dep_pair.dept_id : null,
          vendor_id: config.VENDOR_ID
        }
      }
      this.axios.get(config.API_URL + '/getDashboardSLATicketCount/', qry)
      .then(response => {
        this.dashboardSLATicketCount = response.data
      })
      .catch(err => {
        this.msg(err, true)
      })
    },
    loadDashboardRespResolTime () {
      if(this.lDateFrom != null && this.lDateTo === null) {
        this.lDateTo = this.lDateFrom
      }
      if(this.lDateTo != null && this.lDateFrom === null) {
        this.lDateFrom = this.lDateTo
      }
      var qry = {
        params: {
          from_date: this.lDateFrom,
          to_date: this.lDateTo,
          dept_id: this.lBbSupport.dep_pair? this.lBbSupport.dep_pair.dept_id : null,
          vendor_id: config.VENDOR_ID
        }
      }
      this.axios.get(config.API_URL + '/getDashboardRespResolTime/', qry)
      .then(response => {
        this.dashboardRespResolTime = response.data
      })
      .catch(err => {
        this.msg(err, true)
      })
    },
    loadDepartments () {
      var qry = {
        params: {
          vendor_id: config.VENDOR_ID
        }
      }
      this.axios.get(config.SMARTILITY_API_URL + '/getDepartmentsList/', qry)
      .then(response => {
        //this.departmentList = response.data
        // Load "All Departments as a first item in the combobox"
        this.departmentList.push({
          dept_id: 0,
          dept_name: 'All Departments',
          dept_email_id: ''
        })
        var rec_length = response.data.length
        for(var i = 0; i < response.data.length; i++) {
          if(i < rec_length) {
            this.departmentList.push({
              dept_id: response.data[i].dept_id,
              dept_name: response.data[i].dept_name,
              dept_email_id: response.data[i].dept_email_id
            })
          }
        }
      })
      .catch(err => {
        this.msg(err.response.data, true)
        this.departmentList = []
      })
    },
    loadTicketsDetails (detParam) {
      this.metricsHead = detParam
      this.lAction = 'view-card'
      if(this.lDateFrom != null && this.lDateTo === null) {
        this.lDateTo = this.lDateFrom
      }
      if(this.lDateTo != null && this.lDateFrom === null) {
        this.lDateFrom = this.lDateTo
      }
      var qry = {
        params: {
          from_date: this.lDateFrom + ' 00:00:00',
          to_date: this.lDateTo + ' 23:59:59',
          vendor_id: config.VENDOR_ID,
          dept_id: this.lBbSupport.dep_pair? this.lBbSupport.dep_pair.dept_id : null,
          param: detParam,
          filter: this.filterList
        }
      }
      this.axios.get(config.API_URL + '/getTicketsListForBBDash/', qry)
      .then(response => {
        this.ticketesList = response.data
      })
      .catch(err => {
        this.msg(err)
        this.ticketLists = []
      })
    },
    goBack() {
      this.refreshDashBoard()
      this.lAction = 'view'
    },
    changeView (curView) {
      this.choosenView = curView
    },
    prepareUpdate (curTicket) {
      this.lSupport = Object.assign({}, curTicket)
      this.lSupport.dep_pair = { dept_id: this.lSupport.dept_id, dept_name: this.lSupport.dept_name }
      this.lSupport.cat_pair = { cat_id: this.lSupport.cat_id, cat: this.lSupport.cat }
      this.lSupport.sub_cat_pair = { sub_cat_id: this.lSupport.sub_cat_id, sub_cat: this.lSupport.sub_cat }
      this.lSupport.planned_start_dt = this.lSupport.planned_start_dt ? handy.formatDBDate(this.lSupport.planned_start_dt) : null
      this.lSupport.planned_end_dt = this.lSupport.planned_end_dt ? handy.formatDBDate(this.lSupport.planned_end_dt) : null
      this.lSupport.act_start_dt = this.lSupport.act_start_dt ? handy.formatDBDateTime(this.lSupport.act_start_dt) : null
      this.lSupport.act_end_dt = this.lSupport.act_end_dt ? handy.formatDBDateTime(this.lSupport.act_end_dt) : null
      this.lSupport.job_done_dt = this.lSupport.job_done_dt ? handy.formatDBDateTime(this.lSupport.job_done_dt) : null
      this.lSupport.assigned_to_pair = { emp_id: curTicket.emp_id, emp_name_with_id: curTicket.emp_name_with_id }
      this.previousData = Object.assign({}, this.lSupport)
      this.lSupport.priority_pair = { priority_id: this.lSupport.priority_id, priority: this.lSupport.priority }
      this.lSupport.assign_comments = ''
      this.showAssign = false
      this.UAction = false
      this.loadDepartments(curTicket)
      this.loadTicketAttachment(curTicket.ticket_id)
      this.loadCategories(curTicket)
      this.loadSubCatList(curTicket)
      this.loadAssignUserList(curTicket)
      this.loadPriorityList()
      this.lTAction = 'Update'
    },
    loadCategories (curDept) {
      var qry = {
        params: {
          dept_id: curDept.dept_id,
          vendor_id: config.VENDOR_ID
        }
      }
      this.axios.get(config.SMARTILITY_API_URL + '/getCategoriesBasedOnDeptId/', qry)
      .then(response => {
        this.catList = response.data
      })
      .catch(err => {
        this.msg(err.response.data, true)
        this.catList = []
      })
    },
    loadSubCatList (curCat) {
      var qry = {
        params: {
          cat_id: curCat.cat_id
        }
      }
      this.axios.get(config.SMARTILITY_API_URL + '/getSubCatBasedOnCatId/', qry)
      .then(response => {
        this.subCatList = response.data
      })
      .catch(err => {
        this.msg(err.response.data, true)
        this.subCatList = []
      })
    },
    loadPriorityList () {
      var qry = {
        params: {
          vendor_id: config.VENDOR_ID
        }
      }
      this.axios.get(config.SMARTILITY_API_URL + '/getPriorityList/', qry)
      .then(response => {
        this.priorityList = response.data
      })
      .catch(err => {
        this.msg(err.response.data, true)
        this.priorityList = []
      })
    },
    loadAssignUserList () {
      var qry = {
        params: {
          vendor_id: config.VENDOR_ID
        }
      }
      this.axios.get(config.SMARTILITY_API_URL + '/getBackOfficeStaffs/', qry)
      .then(response => {
        this.assignUserList = response.data
      })
      .catch(err => {
        this.msg(err.response.data, true)
        this.assignUserList = []
      })
    },
    cancelChanges () {
      this.lAction = 'view'
    },
    createSla () {
      this.showSla = true
      this.loadSlaHours()
    },
    prepareDept () {
      this.showDept = true
      this.lDAction = 'view'
    },
    createDept () {
      this.lDept = {
        dept_name: '',
        dept_email_id: '',
        vendor_id: config.VENDOR_ID
      }
      this.lDAction = 'create'
    },
    saveDept (action) {
      // validate and save Changes
      if (this.$refs.acForm.validate()) {
        this.beingSaved = true
        this.lDept.vendor_id = config.VENDOR_ID
        this.axios.post(config.SMARTILITY_API_URL + '/ticket-dept/' + this.lDAction, this.lDept)
        .then(response => {
          // refresh the Category list
          this.loadDepartments(this.lDept)
          this.lDAction = 'view'
          this.beingSaved = false
        })
        .catch(err => {
          this.msg(err)
          this.beingSaved = false
        })
      }
    },
    prepareEditDept (curDept) {
      this.lDept = Object.assign({}, curDept) // keep the original object safely before changes
      this.lDAction = 'update'
    },
    cancelChangesDept () {
      this.lDAction = 'view'
    },
    deleteDept (curDept) {
      if (!confirm('Sure, you want to delete the department "' + curDept.dept_name + '"?')) {
        return
      }
      this.beingSaved = true
      this.axios.post(config.SMARTILITY_API_URL + '/ticket-dept/delete', curDept)
      .then(response => {
        // refresh the ticket category list
        this.loadDepartments(this.lDept)
        this.lDAction = 'view'
        this.beingSaved = false
      })
      .catch(err => {
        this.msg(err.response.data)
        this.beingSaved = false
      })
    },
    prepareCategory () {
      this.showCat = true
      this.lMAction = 'view'
    },
    createCat () {
      this.lCat = {
        cat: '',
        dept_id: this.lSupport.dep_pair.dept_id,
        vendor_id: config.VENDOR_ID
      }
      this.lMAction = 'create'
    },
    saveCat () {
      // validate and save Changes
      if (this.$refs.acForm.validate()) {
        this.beingSaved = true
        this.lCat.vendor_id = config.VENDOR_ID
        this.axios.post(config.SMARTILITY_API_URL + '/ticket-Cat/' + this.lMAction, this.lCat)
        .then(response => {
          // refresh the Category list
          this.loadCategories(this.lCat)
          this.lMAction = 'view'
          this.beingSaved = false
        })
        .catch(err => {
          this.msg(err)
          this.beingSaved = false
        })
      }
    },
    prepareEditCat (curCat) {
      this.lCat = Object.assign({}, curCat) // keep the original object safely before changes
      this.lMAction = 'update'
    },
    deleteCat (curCat) {
      if (!confirm('Sure, you want to delete the Category "' + curCat.cat + '"?')) {
        return
      }
      this.beingSaved = true
      this.axios.post(config.SMARTILITY_API_URL + '/ticket-Cat/delete', curCat)
      .then(response => {
        // refresh the ticket category list
        this.loadCategories(this.lCat)
        this.lMAction = 'view'
        this.beingSaved = false
      })
      .catch(err => {
        this.msg(err.response.data)
        this.beingSaved = false
      })
    },
    cancelChangesCat () {
      this.lMAction = 'view'
    },
    prepareSubCategory () {
      this.showSubCat = true
      this.lSAction = 'view'
    },
    createSubCat () {
      this.lSubCat = {
        sub_cat: '',
        cat_id: this.lSupport.cat_pair.cat_id,
        vendor_id: config.VENDOR_ID
      }
      this.lSAction = 'create'
    },
    saveSubCat () {
      // validate and save Changes
      if (this.$refs.acForm.validate()) {
        this.beingSaved = true
        this.lSubCat.vendor_id = config.VENDOR_ID
        this.axios.post(config.SMARTILITY_API_URL + '/ticket-sub-Cat/' + this.lSAction, this.lSubCat)
        .then(response => {
          // refresh the Category list
          this.loadSubCatList(this.lSubCat)
          this.lSAction = 'view'
          this.beingSaved = false
        })
        .catch(err => {
          this.msg(err)
          this.beingSaved = false
        })
      }
    },
    cancelChangesSubCat () {
      this.lSAction = 'view'
    },
    prepareEditSubCat (curSubCat) {
      this.lSubCat = Object.assign({}, curSubCat) // keep the original object safely before changes
      this.lSAction = 'update'
    },
    deleteSubCat (curSubCat) {
      if (!confirm('Sure, you want to delete the Category "' + curSubCat.sub_cat + '"?')) {
        return
      }
      this.beingSaved = true
      this.axios.post(config.SMARTILITY_API_URL + '/ticket-sub-Cat/delete', curSubCat)
      .then(response => {
        // refresh the ticket category list
        this.loadSubCatList(this.lSubCat)
        this.lSAction = 'view'
        this.beingSaved = false
      })
      .catch(err => {
        this.msg(err.response.data)
        this.beingSaved = false
      })
    },
    saveTicket (action) {
      if (!this.$refs.sForm.validate()) {
        return
      }
      if (!this.lSupport.assigned_to_pair.emp_id) {
        this.msg('Please select assignee from list')
        return
      }
      if (action === 'Update') {
        this.lSupport.notes = ''
        if (this.previousData.cat_pair.cat_id !== this.lSupport.cat_pair.cat_id) {
          this.lSupport.notes += ' Category changed to "' + this.lSupport.cat_pair.cat + '",'
        }
        if (this.previousData.sub_cat_pair.sub_cat_id !== this.lSupport.sub_cat_pair.sub_cat_id) {
          this.lSupport.notes += 'Sub category changed to "' + this.lSupport.sub_cat_pair.sub_cat + '",'
        }
        if (this.previousData.description !== this.lSupport.description) {
          this.lSupport.notes += ' Description from "' + this.previousData.description + '" to "' + this.lSupport.description + '",'
        }
        if (this.previousData.start_dt !== this.lSupport.start_dt) {
          this.lSupport.notes += ' Start date changed to "' + this.lSupport.start_dt + '",'
        }
        if (this.previousData.end_dt !== this.lSupport.end_dt) {
          this.lSupport.notes += ' End date changed to "' + this.lSupport.end_dt + '",'
        }
        if (this.previousData.status !== this.lSupport.status) {
          this.lSupport.notes += ' Status changed to "' + this.lSupport.status + '",'
        }
        if (this.previousData.priority !== this.lSupport.priority) {
          this.lSupport.notes += ' Priority changed to "' + this.lSupport.priority + '",'
        }
        if (this.previousData.assigned_to_pair.emp_id !== this.lSupport.assigned_to_pair.emp_id) {
          this.lSupport.notes += ' Assigned to "' + this.lSupport.assigned_to_pair.emp_name_with_id + '"'
        }
      }
      this.beignSaved = true
      this.lSupport.dept_id = this.lSupport.dep_pair.dept_id
      this.lSupport.cat_id = this.lSupport.cat_pair.cat_id
      this.lSupport.sub_cat_id = this.lSupport.sub_cat_pair.sub_cat_id
      this.lSupport.vendor_id = config.VENDOR_ID
      this.lSupport.updated_by = config.SV_USER_ID
      this.lSupport.action_by = config.SV_USER_ID
      this.lSupport.assigned_to = this.lSupport.assigned_to_pair.emp_id
      this.lSupport.priority_id = this.lSupport.priority_pair.priority_id
      this.lSupport.notes = this.lSupport.notes
      this.lSupport.is_sv_user = true
      this.lSupport.is_action_by_sv_user = true
      this.lSupport.subAction = this.UAction ? 'assigned' : 'updated'
      if (this.lSupport.act_start_dt === null) {
        var curDate = new Date()
        var time = curDate.getHours() + ":" + curDate.getMinutes() + ":" + curDate.getSeconds()
        this.lSupport.act_start_dt = handy.formatDBDate(curDate) + ' ' + time
      } else {
        this.lSupport.act_start_dt = handy.formatDBDateTime(this.lSupport.act_start_dt)
      }
      this.axios.post(config.SMARTILITY_API_URL + '/backOfficeSupport/' + action, this.lSupport)
      .then(response => {
        this.lTAction = 'view-update'
        this.loadTicketsDetails(this.metricsHead)
        this.loadTicketAttachment(this.lSupport.ticket_id)
        this.beingSaved = false
      })
      .catch(err => {
        this.msg(err)
        this.beingSaved = false
      })
    },
    prepareTicketStatus (curTicket, curStatus) {
      this.lTicketStatus = Object.assign({}, curTicket)
      this.lTicketStatus.action = curStatus
      this.lTicketStatus.notes = ''
      this.lTicketStatus.sub_action = 'create'
      this.lTicketStatus.assigned_to_pair = { emp_id: curTicket.emp_id, emp_name_with_id: curTicket.emp_name_with_id }
      if (curStatus === 'Comment') {
        this.placeHolder = 'Type your comment here...'
      } else if (curStatus === 'Need More Info.') {
        this.placeHolder = 'From whom you are looking for information..'
      } else if (curStatus === 'On-hold') {
        this.placeHolder = 'Type your reason for On-hold...'
      } else if (curStatus === 'Completed') {
        this.placeHolder = 'Type your resolution here...'
        this.lTicketStatus.planned_end_dt = this.today
      } else if (curStatus === 'Cancelled') {
        this.lTicketStatus.planned_end_dt = this.lTicketStatus.planned_end_dt ? handy.formatDBDate(this.lTicketStatus.planned_end_dt) : null
        this.placeHolder = 'Type your reason...'
      } else if (curStatus === 'Assigned') {
        this.placeHolder = 'Type your notes if any...'
        this.lTicketStatus.assigned_to_pair = {}
      } else if (curStatus === 'In Progress') {
        this.lTicketStatus.notes += ' Status from "' + this.lSupport.status + '" to "' + curStatus + '".'
      }
      if (curStatus === 'New' || curStatus === 'In Progress') {
        this.postTicketStatus()
      } else if (curStatus === 'On-Hold' || curStatus === 'Need More Info.' || curStatus === 'Comment' || curStatus === 'Assigned' || curStatus === 'Completed' || curStatus === 'Cancelled' || curStatus === 'Reopen' || curStatus === 'Job-Done') {
        this.showDlgStatus = true
      }
      this.loadAssignUserList()
    },
    postTicketStatus () {
      this.lTicketStatus.action_by = config.SV_USER_ID
      this.lTicketStatus.vendor_id = config.VENDOR_ID
      this.lTicketStatus.is_action_by_sv_user = true
      if (this.lTicketStatus.act_start_dt === null) {
        if (this.lTicketStatus.action === 'In Progress' || this.lTicketStatus.action === 'Need More Info.' || this.lTicketStatus.action === 'On-Hold' || this.lTicketStatus.action === 'Assigned') {
          var curDate = new Date()
          var time = curDate.getHours() + ":" + curDate.getMinutes() + ":" + curDate.getSeconds()
          this.lTicketStatus.act_start_dt = handy.formatDBDate(curDate) + ' ' + time
        }
      } else {
        this.lTicketStatus.act_start_dt = handy.formatDBDateTime(this.lTicketStatus.act_start_dt)
      }
      this.lTicketStatus.assigned_to = this.lTicketStatus.assigned_to_pair.emp_id
      this.axios.post(config.SMARTILITY_API_URL + '/backOfficeSupport/status' , this.lTicketStatus)
      .then(response => {
        this.loadTicketsDetails(this.metricsHead)
        this.showDlgStatus = false
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    loadTimeLine (curTicket) {
      var qry = {
        params: {
          ticket_id: curTicket
        }
      }
      this.axios.get(config.SMARTILITY_API_URL + '/getTimelineDetailsByTicketId/', qry)
      .then(response => {
        this.lTimeLine = response.data
        var timeLineNote = []
        timeLineNote = response.data.filter(rec => rec.action === 'Ticket Updated' && rec.notes !== null)
        if (timeLineNote) {
          var note = ''
          var cidx = 0
          for (var k = 0; k < timeLineNote.length; k++) {
            cidx = response.data.findIndex(rec => rec.ticket_det_id === timeLineNote[k].ticket_det_id)
            note = timeLineNote[k].notes.split(',')
            this.lTimeLine[cidx].timeLineNote = []
            for (var i = 0; i < note.length; i++) {
              this.lTimeLine[cidx].timeLineNote[i] = note[i]
            }
          }
        }
        this.loadTicketAttachment(curTicket)
        this.showTimeline = true
        setTimeout(() => {
          var tmpItem = document.getElementById('timeline_' + (this.lTimeLine.length - 1))
          tmpItem.scrollIntoView()
        }, 100)
      })
      .catch(err => {
        this.msg(err, 0)
        this.lTimeLine = []
        this.showTimeline = false
      })
    },
    cancelSaveChanges () {
      this.lTAction = 'view-update'
    },
    pickFile () {
      if (this.lTAction === 'Update') {
        this.$refs.fileInput.click()
      } else {
        this.$refs.statusFileInput.click()
      }
    },
    loadFilesFromFileBrowser (curTicket) {
      let currentDate = new Date()
      let time = currentDate.getHours() + "-" + currentDate.getMinutes() + "-" + currentDate.getSeconds()
      const files = event.target.files
      if (!curTicket.files) {
        curTicket.files = []
      }
      Array.from(files).forEach((file) => {
        const fileReader = new FileReader()
        const getResult = new Promise(resolve => {
          fileReader.onload = e => {
              curTicket.files.push({
                file_url: e.target.result.split(',')[1],
                file_name: file.name.split('.')[0] + '_' + handy.formatDBDate(currentDate) + '_' + time + '.' + file.name.split('.')[1],
                is_selected: true,
                is_changed: true
              })
            this.$forceUpdate()
          }
        })
        fileReader.readAsDataURL(file)
        return getResult.then(file => {
          return file
        })
      })
    },
    loadTicketAttachment (curTicket, curTicketDet) {
      var path = require('path')
      var qry = {
        params: {
          ticket_id: curTicket
        }
      }
      this.lTimeLine.fileUrls = {}
      this.axios.get(config.SMARTILITY_API_URL + '/getAttachmentByTicketId/', qry)
      .then(response => {
        this.lTimeLine.fileUrls = response.data
        // make notes if they have done any change while updating the ticket
        var fileUrls = this.lTimeLine.fileUrls.filter(rec => rec.action === 'Ticket Created' || rec.action === 'Ticket Updated')
        if (fileUrls.length > 0) {
          this.lSupport.files = []
          fileUrls.forEach((rec) => {
            this.lSupport.files.push({
              extension: rec.file_url.split('.')[1],
              file_url: rec.file_url,
              file_name: rec.file_url ? path.basename(rec.file_url) : '',
              is_selected: true,
              is_changed: false,
              action: rec.action,
              ticket_det_id: rec.ticket_det_id,
              ticket_id: rec.ticket_id
            })
          })
        }
        this.lTimeLine.attachImages = []
        this.lTimeLine.attachFile = []
        this.lTimeLine.fileUrls.forEach(rec => {
          rec.extension = rec.file_url.split('.')[1]
          if (rec.extension.toLowerCase() === 'png' || rec.extension.toLowerCase() === 'jpg' || rec.extension.toLowerCase() === 'gif') {
            this.lTimeLine.attachImages.push({
              extension: rec.file_url.split('.')[1],
              file_url: rec.file_url,
              file_name: rec.file_url ? path.basename(rec.file_url) : '',
              is_selected: true,
              is_changed: false,
              action: rec.action,
              ticket_det_id: rec.ticket_det_id,
              ticket_id: rec.ticket_id
            })
          } else {
            this.lTimeLine.attachFile.push({
              extension: rec.file_url.split('.')[1],
              file_url: rec.file_url,
              file_name: rec.file_url ? path.basename(rec.file_url) : '',
              is_selected: true,
              is_changed: false,
              action: rec.action,
              ticket_det_id: rec.ticket_det_id,
              ticket_id: rec.ticket_id
            })
          }
        })
        this.$forceUpdate()
      })
      .catch(err => {
        this.msg(err, true)
        this.lTimeLine.fileUrls = []
      })
    },
    createSla () {
      this.showSla = true
      this.loadSlaHours()
    },
    prepareUpdateSla (curSla) {
      this.lTicketSla = Object.assign({}, curSla)
      this.lSlAction = 'edit'
      this.showSlaCreate = true
    },
    saveChangesSla (action) {
      this.lTicketSla.vendor_id = config.VENDOR_ID
      this.axios.post(config.SMARTILITY_API_URL + '/ticket-sla/' + action, this.lTicketSla)
      .then(response => {
        this.msg('Saved successfully', 1)
        this.loadSlaHours(this.lTicketSla)
      })
      .catch(err => {
        this.msg(err.response.data)
      })
    },
    loadSlaHours () {
      var qry = {
        params: {
          vendor_id: config.VENDOR_ID
        }
      }
      this.axios.get(config.SMARTILITY_API_URL + '/getSlaHoursByVendorId/', qry)
      .then(response => {
        this.tickeSlaHour = response.data
      })
      .catch(err => {
        this.msg(err.response.data)
      })
    },
    removeSelectedFile (curFile) {
      curFile.is_selected = false
      this.$forceUpdate()
    },
    loadFilesFromBrowser (curTicket) {
      const files = event.target.files
      if (!curTicket.files) {
        curTicket.files = []
      }
      Array.from(files).forEach((file) => {
        const fileReader = new FileReader()
        const getResult = new Promise(resolve => {
          fileReader.onload = e => {
            curTicket.files.push({
              file_url: e.target.result.split(',')[1],
              file_name: file.name,
              is_selected: true,
              is_changed: true
            })
            this.$forceUpdate()
          }
        })
        fileReader.readAsDataURL(file)
        return getResult.then(file => {
          return file
        })
      })
    },
    viewAssignComments() {
      this.showAssign = true
      this.UAction = true
    },
    prepareFilter () {
      this.showFilter = true
      this.loadDepartments()
      this.loadAssignUserList()
      this.loadPriorityList()
      this.loadCommunity()
    },
    getEmptyFilter () {
      var filter = {
        comm_id_list: [],
        from_dt: null,
        end_dt: null,
        created_user_pair_list: [],
        assigned_user_pair_list: [],
        ticket_cat_list: [],
        ticket_dept_list: [],
        priority_list: [],
        ticket_status_list: []
      }
      return filter
    },
    loadCreatedUserList (curComm) {
      var qry = {
        params: {
          comm_id: curComm.map(rec => rec.comm_id)
        }
      }
      this.axios.get(config.API_URL + '/getCreatedUserList/', qry)
      .then(response => {
        response.data.forEach(rec => {
          this.mcList.push({user_id: rec.user_id, user_name: handy.startWithUpper(rec.cust_name)})
        })
      })
    },
    loadCommunity () {
      var qry = {
        params: {
          vendor_id: config.VENDOR_ID
        }
      }
      this.axios.get(config.API_URL + '/getCommunityByVendorId/', qry)
      .then(response => {
        this.commList = response.data
      })
      .catch(err => {
        this.msg(err.response.data, 0)
        this.commList = []
      })
    },
    applyFilter () {
      if (this.filterList.comm_id_list.length || this.filterList.assigned_user_pair_list.emp_id || this.filterList.created_user_pair_list.user_id || this.filterList.priority_list.length || this.filterList.ticket_cat_list.length || this.filterList.ticket_status_list.length || this.filterList.ticket_dept_list.dept_id) {
        this.enabledFilter = true
      }
      this.loadTicketsDetails(this.metricsHead)
      this.showFilter = false
      this.$forceUpdate()
    },
    clearFilter () {
      this.filterList.comm_id_list = []
      this.filterList.created_user_pair_list = []
      this.filterList.assigned_user_pair_list = []
      this.filterList.ticket_dept_list = []
      this.filterList.ticket_cat_list = []
      this.filterList.ticket_status_list = []
      this.filterList.priority_list = []
      this.enabledFilter = false
      this.showFilter = false
      this.loadTicketsDetails(this.metricsHead)
      this.$forceUpdate()
    }
  }
}
</script>
